export default {
  bank_product: {
    complete_msg:
      'Chúng tôi chân thành cảm ơn bạn đã <span>đăng ký sản phẩm</span>, và chúng tôi sẽ trả ơn bạn bằng một sản phẩm tốt hơn.',
  },
  enter_amount: 'Vui lòng nhập số tiền.',
  reg_complete: 'Đăng ky đa hoan tât',
  subscription_details: 'Chi tiết đăng ký',
  select_withdrawal_account: 'Chọn tài khoản rút tiền',
  email_address: 'Địa chỉ email',
  product_info: 'Thông tin sản phẩm',
  new_amount: 'Số tiền mới',
  min_running_amount: 'Số tiền thực hiện tối thiểu ',
  max_running_amount: 'Số tiền thực hiện tối đa ',
  product_type: 'Loại sản phẩm',
  bank_product_name: 'tên sản phẩm',
  reg_start_date: 'Ngày bắt đầu đăng ký',
  reg_end_date: 'Ngày kết thúc đăng ký ',
  exec_start_date: 'Ngày bắt đầu thực hiện ',
  exec_end_date: 'Ngày kết thúc thực thi ',
  basic_info: 'Thông tin cơ bản',
  not_applicable: 'Không áp dụng',
  subscription: 'tham gia',
  service_prepare: 'Dịch vụ đang được chuẩn bị.',
  no_buy_list: 'Không có lịch sử mua hàng.',
  no_sell_list: 'Không có lịch sử bán hàng.',
  no_list: 'Không có danh sách.',
  locale_name: 'Tiếng Việt',
  Sale_registration: 'Đăng ký bán',
  apply: 'ứng dụng',
  status: 'trạng thái',
  wallet: 'ví',
  wallet_address: 'Địa chỉ ví',
  wallet_transfer: 'Chuyển khoản',
  buy: 'Mua',
  sell: 'buôn bán',
  all: 'tất cả',
  breakdown: 'Sự cố',
  act_buy: 'Mua',
  act_sell: 'Mua',
  asset: 'tài sản',
  select: 'sự lựa chọn',
  no_select: 'không được chọn',
  account: 'tài khoản',
  balance: 'số dư',
  login: 'đăng nhập',
  logout: 'Đăng xuất',
  register: 'Tham gia Như Thành viên',
  select_cancel: 'Bỏ chọn',
  cancel: 'bị hủy bỏ',
  modify: 'pha lê',
  auto_input: '(Tự động nhập)',
  confirm: 'sự xác nhận',
  look_up: 'tài liệu tham khảo',
  password: 'mật khẩu',
  account_delete: 'sự phân ly',
  detail: 'hơn',
  list_detail: 'Xem chi tiết',
  birth: 'ngày sinh nhật',
  welcome: 'Chào mừng bạn.',
  please_login: 'Hãy đăng nhập.',
  confirmation_login: 'Bạn có thể kiểm tra nó khi bạn đăng nhập.',
  id: 'Tên đăng nhập',
  find_id: 'Tìm ID',
  find_password: 'Quên mật khẩu',
  back: 'trả lại',
  agreement: 'Điều khoản thỏa thuận',
  info_input: 'thông tin đầu vào',
  success: 'hoàn toàn',
  agree_msg: 'Tôi đồng ý.',
  all_agree: 'Tôi đồng ý với tất cả',
  agree: 'Đồng ý',
  agreed: 'Đã đồng ý',
  confirm_password: 'Xác nhận mật khẩu',
  repeat_password: 'Xác nhận mật khẩu',
  next: 'Kế tiếp',
  before: 'Quay lại',
  register_success: 'Đăng ký ngay bây giờ.',
  verify: 'sự xác nhận',
  retention: 'Retention',
  allow: '(Chấp nhận)',
  disallow: '(Được chấp nhận)',
  upload_btn: 'Hãy thả file, hoặc bấm vào đây.',
  continue_entry:
    'Vui lòng nhập của bạn: "[+:verification]" Để tiếp tục bên dưới.',
  login_msg_1: 'tài khoản Hãy thử trong ONETETHER Coin liên quan !',
  login_msg_2:
    'Qua ONETETHERER của chúng tôi xin vui lòng sử dụng thỏa thuận này và ví và dịch vụ.',
  login_msg_3: 'ONETETHERER có thể hỗ trợ tất cả các môi trường.',
  cocofx_register: 'ONETETHERER Đăng ký',
  register_msg_1:
    'Tham gia là Ủy viên. <br /> Vui lòng đồng ý với các điều khoản và điều kiện của chúng tôi',
  register_msg_3:
    'Một tài khoản ONETETHERER sẽ cung cấp quyền truy cập cho tất cả các dịch vụ thoải mái.',
  register_msg_all:
    'Đồng ý với tất cả bao gồm sự đồng ý với các mục bắt buộc và tùy chọn, và bạn có thể chọn đồng ý riêng.Ngay cả khi bạn từ chối đồng ý với các tùy chọn, dịch vụ vẫn có sẵn.',
  register_title: 'Tôi trên 19 tuổi trở lên.',
  register_title_2: 'Điều kiện ONETETHERER',
  register_title_3: 'ONETETHERER Integration Điều khoản Dịch vụ',
  register_title_4: 'ONETETHERER thị đòn bẩy đồng ý',
  register_title_5: 'Việc thu thập và sử dụng thông tin cá nhân đồng ý',
  register_title_6: 'Việc thu thập và sử dụng thông tin vị trí thỏa thuận',
  register_title_7: 'Tôi đồng ý thu thập thông tin hồ sơ bổ sung',
  register_title_8: 'Input ONETETHERER Thông tin tài khoản',
  register_title_9: 'Thông tin đầu vào',
  register_msg_4:
    'Những thuật ngữ này áp dụng cho tất cả các dịch vụ được cung cấp bởi công ty. <br /> Bằng cách đồng ý với những điều khoản này, bạn có thể sử dụng các dịch vụ mà không ký hợp đồng riêng biệt.',
  required: '[Cần thiết]',
  option: '[Selective]',
  otp_notice: 'Trạng thái được kích hoạt và vô hiệu hoá OTP không thể.',
  required_check: 'Vui lòng kiểm tra tất cả các trường bắt buộc',
  check_input: 'Vui lòng nhập tất cả các chi tiết.',
  register_guide: 'Làm thế nào để sử dụng ONETETHERER',
  register_step1: 'Nhấn ONETETHERER Nút',
  register_step2: 'Đăng nhập vào ONETETHERER',
  register_step3: 'Pay / Recharge ONETETHERER Log In',
  copy: 'Sao chép',
  no_account: 'Có tài khoản không đăng ký.',
  inviter_link: 'liên kết giới thiệu',
  register_used_account: 'Đăng ký tài khoản thường xuyên sử dụng',
  security_certification: 'chứng nhận an ninh',
  admin_security: 'Mức độ bảo mật cho {action} là {limit}.',
  company: 'doanh nghiệp',
  exact_calculation: 'điều chỉnh',
  profile: 'Thông tin cá nhân',
  inquiry: 'Tin nhắn của bạn',
  inquiry_history: 'Chi tiết liên lạc',
  announcement: 'thông tin',
  information: 'Thông tin',
  history: 'lịch sử',
  registration_date: 'Ngày đăng ký',
  pay: 'thanh toán',
  detail_search: 'Full Text Search',
  more_view: 'Xem thêm',
  exchange_store: 'trao đổi',
  external_exchange_store: 'Trao đổi bên ngoài',
  internal_exchange_store: 'Trao đổi nội bộ',
  external_transaction: 'Giao dịch bên ngoài',
  internal_transaction: 'Giao dịch nội bộ',
  favorites: 'Yêu thích',
  no_favorite_list: 'Không có mục yêu thích.',
  no_alias: 'Không có bí danh',
  please_enter_account_name: 'Vui lòng nhập tên tài khoản của bạn.',
  variable_amount: 'Số lượng biến đổi',
  changes: 'Những thay đổi',
  account_transaction_history_inquiry: 'Truy vấn lịch sử giao dịch tài khoản',
  exchange_application_completed: 'Đơn xin đổi tiền đã hoàn tất.',
  choose_how_pay_fee: 'Chọn cách thanh toán phí',
  free: 'miễn phí',
  closing: 'đóng cửa',
  relative_asset_inquiry: 'Truy vấn tài sản tương đối',
  please_enter_relative_account_number: 'Vui lòng nhập số tài khoản tương đối.',
  Please_enter_relative_wallet_address: 'Vui lòng nhập địa chỉ ví tương đối.',
  memo: 'ghi nhớ',
  write_history_memo: 'Sẽ rất thuận tiện để quản lý nếu bạn ghi lại lịch sử.',
  re_enter: 'Nhập lại',
  transfer_wallet_account: 'Chuyển địa chỉ ví',
  transfer_wallet_inquiry: 'Yêu cầu chuyển ví',
  Kiosk: 'Kiosk',
  withdrawable_amount: 'Số tiền có thể rút',
  transferred_assets: 'Chuyển giao tài sản',
  recipient: 'Người nhận',
  recipient_wallet: 'Ví người nhận',
  register_user_name_tit:
    'Chúng tôi khuyên bạn nên điền vào tên thật để chứng nhận bảo mật.',
  register_password_tit:
    'Vui lòng điền vào địa chỉ email thường xuyên được sử dụng chính xác.',
  product_name: 'Tên sản phẩm',
  dividend_type: 'loại cổ tức',
  auto: 'Tự động',
  manual: 'Hướng dẫn',
  s_usdt_protocol: 'Chọn một giao thức TETHER',
  ccf: {
    what_ccf: 'CCFとは？?',
    key_coin:
      'Đồng tiền chủ chốt của ONETETHERER kết nối tiền điện tử với tiền tệ thực',
    ccf_description:
      'Đây là đồng tiền chủ chốt của ONETETHERER có thể chuyển đổi các loại tiền điện tử khác nhau thông qua trao đổi trực tiếp và giao dịch C2C, và 1CCF có giá trị 1CENT USD. CCF cho phép mua hàng và giao dịch nhanh hơn và an toàn hơn trêONETETHERTHER.',
    how_use_ccf: 'Làm thế nào để sử dụng CCF?',
    cocobank_wallet_transfer:
      'Chuyển tài sản tiền điện tử được lưu trữ trên các sàn giao dịch bên ngoài vào ví của ONETETHERER.',
    ccf_conversion:
      'Chuyển đổi tiền điện tử được chuyển trong ví sang CCF thông qua trao đổi tiền tệ trực tiếp hoặc giao dịch C2C.',
    direct_exchange_c2c_deal: 'Trao đổi tiền tệ trực tiếp giao dịch C2C',
    ccf_moved:
      'CCF đã chuyển đổi sẽ được chuyển vào tài khoản ONETETHERER của bạn.',
    how_use_account_ccf:
      'CCF chuyển vào tài khoản của bạn được sử dụng như thế này!',
    freely_purchase_open_market:
      'Tự do mua các sản phẩm thị trường mở với CCF!',
    free_deposit_withdrawal:
      'Miễn phí gửi, rút ​​và chuyển khoản giữa các tài khoản trong ngân hàng!',
    exchange_currencies_convenient:
      'Trao đổi giữa các loại tiền tệ trở nên thuận tiện thông qua trao đổi tiền tệ trực tiếp và giao dịch C2C!',
    offline_convenient:
      'Sử dụng dịch vụ của ONETETHERER tiện lợi hơn ngay cả khi ngoại tuyến!',
    how_wallets_accounts_different: 'Ví và tài khoản khác nhau như thế nào?',
    same_means_storing_cryptocurrency:
      'Trong ONETETHERER, ví và tài khoản là những phương tiện lưu trữ tiền điện tử giống nhau, nhưng việc sử dụng chúng khác nhau tùy thuộc vào loại giao dịch (nội bộ và bên ngoài) của tiền điện tử. Nói cách khác, ví được sử dụng cho các giao dịch (bên ngoài) giữa sàn giao dịch vONETETHERTHER, và tài khoản được sử dụng cho các giao dịch (nội bộ) trONETETHERTETHER.',
  },
  header: {
    certification_management: 'Chứng nhận / Quản lý',
    c2c_enroll: 'Mua / Bán',
    wallet_list: 'Wallet / Lịch sử &',
    wallet: 'ví',
    c2c_list: 'lịch sử mua / bán hàng',
    no_c2c_sell_list: 'Không có lịch sử bán hàng.',
    transfer_list: 'Lịch sử giao dịch ngoại tệ',
    no_transfer_list: 'Không có lịch sử trao đổi.',
    withdrawal_list: 'Input / Lịch sử Rút',
    my_info: 'Thông tin cá nhân',
    home: 'Maine',
    account_transfer: 'Chuyển tài khoản',
    transfer_history: 'lịch sử chuyển',
    register_used_account: 'Đăng ký tài khoản thường xuyên sử dụng',
    exchange: 'để trao đổi',
    exchange_list: 'Lịch sử giao dịch ngoại tệ',
    email: 'E-mail',
    email_list: 'Lịch sử email',
    otp: 'OTP',
    otp_list: 'Lịch sử OTP',
    register_account: 'tài khoản đăng ký',
    calculation_account_list: 'Giải quyết danh sách tài khoản',
    security_certification: 'chứng nhận an ninh',
    exact_calculation: 'điều chỉnh',
    history: 'lịch sử',
    coco_open_market: 'Thị trường mở COCO',
    information: 'Thông tin',
    my_profile: 'Thông tin cá nhân',
    email_modify: 'chỉnh sửa email',
    password_modify: 'Chỉnh sửa mật khẩu',
    inquiry: 'Tin nhắn của bạn',
    one_on_one_inquiry: '1:1 Tin nhắn của bạn',
    frequently_asked_questions: 'Hỏi đáp',
    announcement: 'thông tin',
    notice: 'thông báo',
    server_notice: 'máy chủ Thông báo',
    service_center: 'trung tâm dịch vụ',
    profile: 'Thông tin cá nhân',
    company: 'doanh nghiệp',
    account_management: 'Quản lý tài khoản',
    do_exchange: 'để trao đổi',
    transfer: 'chuyển',
    look_up: 'tài liệu tham khảo',
    faq: 'Hỏi đáp',
    server: 'máy chủ',
    email_request: 'email Liên hệ',
    Product_Subscription: 'Sản phẩm & Đăng ký',
    easy_payment: 'Thanh toán dễ dàng',
    easy_login: 'đăng nhập dễ dàng',
  },
  footer: {
    footer_msg:
      'Tận dụng lợi thế của các tài khoản đồng xu liên quan trong ONETETHERER!',
    footer_sub_msg:
      'Qua ONETETHERER của chúng tôi xin vui lòng sử dụng các giao dịch và các dịch vụ ví',
    footer_sub_msg2: 'đầu',
    footer_sub_msg3: 'ONETETHERER có thể hỗ trợ tất cả các môi trường.',
    ICO: 'ICO',
    c2c: 'C2C Trao đổi',
    b2c: 'trao đổi B2C',
    margin_exchange: 'lề trao đổi',
    gift_exchange: 'Futures Exchange',
    Binary: 'binary Tùy chọn',
    open_marcket: 'mở Market',
    game: 'Trò chơi',
    proceed: 'các giao dịch liên tục',
    public: 'IPO Tin',
    direct_ex: 'trao đổi trực tiếp',
    buy: 'Mua',
    sell: 'Mua',
    buy_sell: 'Mua / bán',
    holding_coin: 'nắm giữ đồng xu',
    fee: 'phí Hướng dẫn',
    exchange: 'trao đổi',
    transfer_record: 'Lịch sử giao dịch',
    Leverage: 'Đòn bẩy',
    live_exchange: 'Giao dịch trực tiếp',
    demo_exchange: 'Demo Thương mại',
    contest: 'tập hợp',
    powerball: 'Powerball',
    law:
      'Pháp lý: số đăng ký ONETETHERER.COM của: 70638826927 (U 6 29 Railway PDE EastwoodNSW 2122)',
    law1:
      'Thương mại Point of Financial Instruments Chủ sở hữu của toàn bộ Ltd (Australia) là ONETETHERER PTY TNHH Số đăng ký: 70638826927 thương hiệu.',
    law2:
      'Trang web này được cung cấp bởi ONETETHERER CorpONETETHERTHER Corp đã được phê duyệt số 64.190 - là theo quy định của các dịch vụ tài chính phụ trợ, nó được đăng ký tại số tham chiếu 70638826927 Úc.',
    law3: 'ONETETHERER hoạt động theo nguyên tắc đầu tư sản phẩm tài chính Úc.',
    law4:
      'ref. không. 538.324 | ABN reg. 70638826927 | BA reg. 64190. Để chắc chắn rằng bạn được phép sử dụng dịch vụ ONETETHERER trong quy định pháp luật của nước cư trú là trách nhiệm duy nhất của khách hàng.',
    law5: 'Xin vui lòng đọc Tiết lộ rủi ro ONETETHER chuyên nghiệp FX.',
    law6:
      'ONETETHERER không cung cấp dịch vụ cho Hoa Kỳ, Belize, Mauritius, Nhật Bản, Alberta, British Columbia, Quebec, Saskatchewan Cư dân của Saskatchewan, Haiti, Suriname, Bắc Triều Tiên, Puerto Rico và các khu vực chiếm đóng của Síp.',
    law7:
      'Vui lòng tham khảo phần điều tiết của FAQ để biết thêm thông tin. Vui lòng tham khảo bố rủi ro của chúng tôi.',
    law8:
      'khu vực hạn chế: Kinh doanh Quan điểm của Financial Instruments TNHH không cung cấp đầu tư và dịch vụ phụ trợ cho các nước thế giới thứ ba và vùng lãnh thổ.',
    law_warn: 'Cảnh báo rủi ro:',
    law_1:
      'CFD có nguy cơ cao và các sản phẩm phức tạp một cách nhanh chóng mất tiền của họ do đòn bẩy. 69,10% của các nhà đầu tư cá nhân chiếm nó sẽ bị mất tiền khi giao dịch CFD.',
    law_2:
      'Bạn phải xem xét liệu bạn có thể chấp nhận sự thật rằng bạn hiểu CFD làm việc, cao hơn các nguy cơ mất tiền. Vui lòng tham khảo bố rủi ro của chúng tôi.',
    alert_title: 'Note và Note',
    coco_market: 'thị trường COCO',
    ieo_market: 'thị trường IEO',
    news: 'Tin tức',
    event: 'biến cố',
    platform_rental_title: 'nền tảng cho thuê',
    education: 'giáo dục',
    online_Academy: 'Học viện trực tuyến',
    offline_Academy: 'ẩn Academy',
    shopping_basket: 'giỏ mua sắm',
    best_product: 'Giao dịch tốt nhất',
    order: 'đặt hàng',
    my_page_title: 'trang của tôi',
    member_info_management: 'Quản lý tài khoản',
    order_management: 'Quản lý trật tự',
    my_question: 'câu hỏi của tôi',
    one_enquiry: '01:01 Liên hệ',
    community: 'cộng đồng',
    lotto: 'xổ số Powerball',
    rock_event: 'đá tổ chức sự kiện',
    quiz_game: 'trivia game',
    ladder_game: 'Thang',
    tetris: 'Tetris',
    split_lotto: 'Lotto chia',
    day_Lottery: 'xổ số kiến ​​thiết hàng ngày',
    attendance: 'kiểm tra tham dự',
    scoop_out: 'Nhúng',
    forum: 'diễn đàn',
  },
  main_msg: {
    about_1_title: 'Điều tốt nhất thế giới dịch vụ giao dịch tiền tệ mật khẩu',
    about_1_msg: 'Tất cả các dịch vụ liên quan đến đồng xu dẫn ONETETHERER.',
    about_1_1_msg:
      'Sẵn sàng cho thời gian bán hàng cryptocurrency đồng xu đầu tiên ở một nơi trên thế giới.',
    about_1_2_msg: 'Đối với việc trao đổi trực tiếp nó có sẵn tại ONETETHERER.',
    about_2_title: 'Ngay lập tức hệ thống trao đổi',
    about_2_msg:
      'ONETETHERER sử dụng một công nghệ phù hợp ổn định đa song song Ngay lập tức áp dụng các công nghệ thiết kế tiên tiến để cho phép giao dịch Cổ phiếu hệ thống trao đổi.',
    about_3_title: 'Wallet tạo',
    about_3_msg:
      'chuyên gia bảo mật đã được ONETETHERER gồm các kỹ sư tốt nhất tại Hàn Quốc Được trang bị với hệ thống an ninh nhà nước-of-the-art cung cấp hệ thống Wallet.',
    about_4_title: 'hệ thống giao dịch đơn giản (C2C)',
    about_4_msg:
      'ONETETHERER là xây dựng một đơn giản, hệ thống giao dịch sử dụng Hãy cho phép một giao dịch thuận tiện hơn.',
    c2c_main_msg1_1:
      'ONETETHERER sẽ ngay lập tức trao đổi sử dụng đáng tin cậy công nghệ phù hợp với đa song song',
    c2c_main_msg1_2:
      'Giữ hệ thống trao đổi, áp dụng các kỹ thuật thiết kế tiên tiến để kích hoạt và',
    c2c_main_msg1_3: 'Có.',
    c2c_main_msg2_1:
      'chuyên gia bảo mật đã được ONETETHERER gồm các kỹ sư tốt nhất tại Hàn Quốc',
    c2c_main_msg2_2:
      'Được trang bị với hệ thống an ninh nhà nước-of-the-art cung cấp hệ thống Wallet.',
    c2c_main_msg3_1:
      'ONETETHERER là dễ dàng hơn đối với hệ thống giao dịch sử dụng xây dựng',
    c2c_main_msg3_2: 'Nó cho phép kinh doanh dễ dàng.',
  },
  toasted_msg: {
    agree_required_term:
      'Vui lòng đồng ý với các điều khoản và điều kiện bắt buộc',
    must_read_term:
      'Bạn phải đọc hoặc tải xuống tất cả các điều khoản và điều kiện.',
    confirm: 'Nó đã được xác định',
    changed: 'Những thay đổi đã',
    withdrawal: 'rút là',
    register: 'Nó đã được đăng ký.',
    delete: 'Nó đã bị xóa.',
    title: 'thông báo',
    exchange: 'trao đổi trực tiếp đã được xử lý thành công.',
    search: 'Nó được xem.',
    deposit_request: 'Ứng dụng đã được gửi.',
    withdraw_request: 'Rút đã được áp dụng.',
    create_account: 'Nó đã được mở ra.',
    modify: 'Nó đã được cố định.',
    cancel: 'Nó đã bị hủy.',
    trade_confirm: 'Thương mại đã được thành lập.',
    trade_reject: 'Deal từ chối.',
    copy: 'Sao chép.',
    nice_msg:
      'Nếu bạn không cần phải được vô hiệu hóa trong cài đặt trình duyệt của bạn pop-up xác thực danh tính không tiến hành bình thường.',
    nice_title: 'Thông tin',
    nice_success: 'xác thực danh tính đã được xử lý thành công.',
    nice_error: 'Không thể xác minh danh tính của bạn.',
    no_transfer: 'Không trao đổi thông tin.',
    email_auth: 'Xác thực email được thực hiện thành công.',
    email_auth_send: 'Email này đã được gửi đến cấp giấy chứng nhận.',
    kyc_withdraw: 'xác thực tài khoản đã thành công.',
    not_allow_trade: 'Deal không hoạt động.',
    id_find_mail_send: 'ID đã được gửi qua e-mail.',
    duplicate_check: 'ID trùng lặp hoặc email.',
    pay: 'Thanh toán hoàn tất.',
  },
  private: {
    deal_list: 'Lịch sử bán hàng',
    app_list: 'lịch sử mua hàng',
    deal_buy_asset: 'Tài sản được mua',
    buy_price: 'giá mua',
    confirmed_source_amount: 'Xác nhận bán hàng',
    holding_source_amount: 'chưa được xác nhận bán hàng',
    potential_source_amount: 'Số lượng sẵn',
    direct_market: 'trao đổi trực tiếp',
    deal_enroll: 'bán',
    app_enroll: 'để mua hàng',
    select_market: 'Chọn thị trường',
    fee_rate: 'hoa hồng',
    deal_info_input: 'Nhập thông tin bán hàng',
    deal_source_amount: 'bán hàng',
    deal_price: 'Giá cho mỗi đơn vị',
    deal_enroll_account: 'Tài khoản cho Bán',
    account_select: 'Chọn Tài khoản',
    direct_asset_select: 'Vui lòng chọn một bán bất động sản và mua',
    please_select_asset: 'Vui lòng chọn một tài sản.',
    basic_rate: 'giá thị trường',
    direct_transfer_buy: 'mua ngay lập tức',
    direct_transfer_sell: 'Ngay tại thời điểm bán',
    direct_source_amount: 'Đơn vị giao dịch ngoại tệ',
    direct_target_amount: 'Áp dụng Số lượng',
    direct_asset_buy: 'Mua {0}',
    direct_asset_sell: 'Bán thuốc lá cho {0}',
    selected_deal_info: 'Thông tin bán hàng được lựa chọn',
    deal_source_asset_title: 'tài sản mua',
    deal_total_source_amount: 'Tổng khối lượng bán hàng',
    app_info_input: 'Nhập thông tin mua hàng',
    app_amount: 'khối lượng mua',
    app_deal_price: 'giá',
    pay_target_amount: 'Số lượng trả tiền để làm',
    fee: 'hoa hồng',
    fee_calc: 'số tiền lệ phí',
    msg_fee_calc: 'Như {0} sẽ được khấu trừ.',
    app_account: 'Chiếm mua hàng',
    app_receive_account: 'Chọn tài khoản để nhận',
    c2c_buy_select_asset: 'Vui lòng chọn mua bất động sản',
    go_home: 'Quay lại trang',
    buy_calc_spread: 'mua ngoại tệ',
    sell_calc_spread: 'bán ngoại tệ',
    cs_market_asset: 'tài sản cặp',
    cs_market_basic_rate: 'tỷ giá tham chiếu marketing',
    transfer_type: 'Trao đổi Loại',
    exchange_rate: 'tỷ giá',
    submit_transfer: 'ngay lập tức trao đổi',
    deal_source_min_amount: 'Số lượng mua tối thiểu',
    closed_date: 'Chấm dứt một',
    no_deal: 'Không có danh sách bán hàng',
    app_price_per_quantity: 'Giá per Unit',
    app_fee_amount: 'Tổng số phí',
    select_deal_app_list: 'Mua bán hàng lựa chọn',
    no_select_deal_app_list: 'Không mua hàng trong doanh thu của nó',
    transfer_source_amount: 'Dựa vào số lượng tài sản',
    transfer_target_amount: 'Đối với tài sản Số lượng',
    transfer_basic_rate: 'tỷ giá tham chiếu áp dụng cho bán',
    transfer_spread_rate: 'lây lan tỷ lệ ứng dụng',
    transfer_exchange_rate: 'tỷ giá',
    transfer_list_detail: 'Trao đổi Yêu cầu thêm chi tiết',
    transfer_source_asset: 'Dựa trên tài sản',
    transfer_target_asset: 'Đối với tài sản',
    transfer_source_account_number: 'Dựa vào số tài khoản tài sản',
    transfer_target_account_number: 'Đối với số tài khoản tài sản',
    transfer_detail_type: 'Trao đổi Loại',
    transfer_regdate: 'Áp dụng một',
    transfer_asset_info: '{0} đến {1} {2}',
    transfer_asset_select: 'Vui lòng chọn nội dung bạn muốn thay thế.',
    msg_transfer_buy: 'Mua {0}',
    msg_transfer_sell: 'Bán thuốc lá cho {0}',
    deal_fee_amount: 'phí bán bên bố áp đặt',
  },
  wallet_page: {
    have_asset: 'tài sản',
    asset_list: 'Danh sách Tài sản',
    account_list: 'Danh sách tài khoản',
    account_create: 'tạo tài khoản',
    deposit: 'Tiền đặt cọc',
    withdraw: 'sự rút lui',
    deposit_list_look: 'Tiền đặt cọc Lookup',
    deposit_look: 'Tiền đặt cọc lần xem',
    withdraw_list_look: 'Rút Lịch sử &',
    withdraw_look: 'rút xem',
    account_modify: 'Sửa tài khoản',
    deposit_apply: 'Đơn đặt cọc',
    withdraw_apply: 'ứng dụng bị thu hồi',
    deposit_request_amount: 'tiền đặt cọc Số tiền',
    withdraw_request_amount: 'rút Amount',
    withdraw_account_info: 'Thông tin tài khoản rút',
    holder_name: 'Tên Chủ Tài khoản',
    bank_name: 'Tên Ngân hàng',
    withdraw_bank_address: 'Số tài khoản',
    withdraw_address: 'địa chỉ bất động sản',
    qr_address: 'địa chỉ tài khoản',
    create_qr_address: 'Tài khoản mạc Địa chỉ',
    account_enroll: 'đăng ký tài khoản',
    account_seq: 'số ID tài khoản',
    account_title: 'Tên tài khoản',
    regdate: 'Gaeseolil',
    before_regdate: '(Trước khi khai mạc)',
    holding_balance: 'Dừng số tiền',
    select_asset: 'Chọn bất động sản',
    create: 'mở',
    deposit_list: 'Tiền đặt cọc',
    no_deposit_list: 'Không có chi tiết ứng dụng tiền gửi.',
    deposit_apply_detail: 'Tiền đặt cọc Yêu cầu thêm chi tiết',
    asset_title: 'tài sản',
    request_amount: 'Số tiền yêu cầu',
    withdraw_list: 'Lịch sử rút',
    no_withdraw_list: 'Không có yêu cầu rút tiền.',
    withdraw_apply_detail: 'Rút Yêu cầu thêm chi tiết',
    withdraw_fee_total_amount: 'Tổng số tiền rút (bao gồm phí)',
    net_amount: 'số tiền cuối cùng',
    fee_type: 'loại phí',
    fee_charge_type: 'Fee charge type',
    amount_of_fee: 'Amount of fee',
    create_account_address: 'Tài khoản mạc Địa chỉ',
    deposit_msg: 'Đặt cọc ví của tôi {0} {0} từ bên ngoài của chiếc ví.',
    deposit_msg_1:
      'Khi được chấp nhận 350 lần (xác nhận) trên chuỗi khối {0} giao dịch được phản ánh trong ví.',
    deposit_step_1: 'Bước 1. Kiểm tra ID {0} bản ghi nhớ đầu tiên.',
    deposit_step_1_1: 'ghi chú ID của tôi {0}',
    deposit_step_1_2:
      '{0} phải đánh dấu ID ghi chú của riêng bạn khi bạn đặt cọc. {0}, không có ghi chú chuyển ID bị mất.',
    deposit_step_1_3: 'Xem {0} địa chỉ Wallet của bạn.',
    deposit_step_1_btn: 'Ghi chú ID Copy',
    deposit_step_2: 'Bước 2. Kiểm tra địa chỉ ví của bạn.',
    deposit_step_2_1: 'mã QR',
    deposit_step_2_2: 'Wallet Địa chỉ',
    deposit_step_2_3:
      'Số tiền ký quỹ tối thiểu là <span style = "color: # 4a90e2"> {0} {1} là </ span>.',
    deposit_step_2_btn: 'Ví Chép Địa chỉ',
    deposit_msg_2: 'Vui lòng kiểm tra',
    deposit_msg_2_1: 'Địa chỉ này là địa chỉ cho chỉ huy.',
    deposit_msg_2_2:
      'Tổng thời gian cần thiết để phù hợp với hoàn có thể bị ảnh hưởng bởi tình trạng tắc nghẽn của mạng lưới chuỗi khối, cryptocurrency sao Khối Chaining tắc nghẽn là <span style = "color: #4a90e2; cursor: pointer;"> đây </span> bạn có thể kiểm tra.',
    no_account_list: 'Không có danh sách tài khoản.',
    no_favorite_account_list: 'Không có danh sách tài khoản yêu thích.',
    input_account: 'Vui lòng nhập tên tài khoản của bạn để thay đổi.',
  },
  my_page: {
    my_profile: 'Thông tin cá nhân',
    user_unique_num: 'Số nhận dạng thành viên',
    user_name: 'tên người dùng',
    email_address: 'E-mail',
    register_regdate: 'từ',
    last_login: 'Bài đăng nhập',
    auth_complete: 'chứng nhận',
    not_auth: 'Không được chứng nhận',
    expdate: 'hết hạn',
    act_auth: 'Chứng thực',
    realname_auth: 'xác thực danh tính',
    email_auth: 'xác thực email',
    otp_auth: 'xác thực OTP',
    enroll: 'đăng ký doanh nghiệp',
    security: 'Cấp an ninh',
    show_security: 'Xem Cấp An',
    auth_withdraw_address: 'Rút Địa chỉ Xác thực',
    apply_list: 'Áp dụng Lịch sử',
    password_modify: 'Chỉnh sửa mật khẩu',
    email_modify: 'chỉnh sửa email',
    account_block: 'Tài khoản rút',
    placeholder_old_password: 'Vui lòng nhập mật khẩu cũ của bạn',
    placeholder_new_password: 'Vui lòng nhập mật khẩu mới',
    placeholder_confirm: 'Vui lòng nhập một lần nữa',
    placeholder_password: 'Vui lòng nhập mật khẩu của bạn',
    placeholder_email: 'Nhập email mới',
    mail_cert_list: 'Lịch sử ứng dụng Email',
    no_mail_list: 'Không có lịch sử ứng dụng email.',
    nominee_detail: 'Lịch sử vòng tròn pholicular',
  },
  kyc: {
    register_account: 'tài khoản đăng ký',
    kyc_enroll: 'Ứng dụng KYC Xác thực',
    kyc_enroll_2: 'KYC chứng minh địa chỉ',
    kyc_enroll_3: 'KYC Lý do điều chỉnh tăng 4 bước',
    auth: 'Chứng nhận',
    auth_code_send: 'Gửi mã xác thực',
    auth_code: 'authentication Code',
    msg_auth_code: 'Vui lòng nhập mã xác minh trong vòng 5 phút.',
    type_title: 'Tên của các loại',
    withdraw_auth: 'Rút Địa chỉ Xác thực',
    withdraw_auth_tit:
      'Một thủ tục xác thực địa chỉ khách quan để khấu trừ bên ngoài. Vui lòng đăng ký tài khoản mục tiêu và địa chỉ ví sẽ được mua.',
    select_asset: 'Chọn bất động sản',
    select_bank: 'Chọn Ngân hàng',
    holder_name: 'Tên Chủ Tài khoản',
    birth: 'ngày 6 chữ số năm sinh',
    address: 'địa chỉ bất động sản',
    withdraw_list: 'Rút Lịch sử ứng dụng Tài khoản',
    bank_name: 'Tên Ngân hàng',
    withdraw_info: 'Thông tin tài khoản rút',
    withdraw_complete: 'bất động sản đã hoàn thành cấp giấy chứng nhận này.',
    regdate: 'thêm',
    delete_withdraw_address: 'địa chỉ ghi nợ đã thay đổi',
    delete_success_address: 'Địa chỉ rút đã thay đổi.',
    kyc_cert_list: 'Lịch sử Application KYC',
    no_kyc_list: 'KYC là không có tiền sử ứng dụng.',
    no_kyc_withdraw_address_list:
      'Không có lịch sử ứng dụng tài khoản thanh toán.',
    kyc_placeholder: 'Vui lòng nhập.',
  },
  otp: {
    enter_verification_number: 'Nhập mã số xác nhận OTP',
    otp_auth: 'xác thực OTP',
    authenticode: 'OTP phím',
    otp_deactivate: 'OTP tàn tật',
    msg_authenticator_installation:
      '"Google Authenticator" ứng dụng, hãy cài đặt trên điện thoại thông minh hoặc máy tính để bàn của bạn',
    android: 'Android',
    or: 'hoặc',
    iphone_series: 'iPhone, iPad và iPod',
    windows_phone: 'windows Phone',
    and: 'và',
    msg_microsoft_other_systems:
      'Các hệ thống khác, bao gồm Microsoft Windows máy tính để bàn',
    msg_key: 'Chìa khóa',
    msg_use_loss_change:
      'Hãy viết lên giấy. Bị mất hoặc thiết bị đầu cuối được sử dụng khi bạn cần phải thay đổi OTP.',
    msg_brcode_touch:
      'Khởi động "Google Authenticator" ứng dụng giá xin vui lòng khai thác <b> Scan QR mã vạch </ b> ở dưới cùng của màn hình.',
    msg_input_authenticode:
      'Vui lòng nhập mã xác nhận hiển thị trên màn hình thiết bị đầu cuối trong "Mã xác thực" dưới đây.',
    otp_key: 'OTP phím',
    otp_activate: 'OTP kích hoạt',
    otp_copy: 'Các phím OTP sao chép.',
    otp_safe_keeping:
      'Ít sau đó đã làm chìa khóa OTP trên giấy và lưu trữ nó vào một nơi an toàn không?',
    yes: 'bốn',
    otp_register: 'tuyển sinh',
    otp_register_success: 'Việc đăng ký OTP được hoàn thành thành công.',
    otp_delete_success: 'hủy OTP của việc đăng ký được thực hiện thành công.',
    msg_click_key_copy: 'Nhấp chuột vào phím sao chép.',
    otp_login: 'Đăng nhập OTP',
  },
  security: {
    show_security: 'Xem Cấp An',
    grade: 'Đánh giá',
    condition: 'điều kiện',
    restriction: 'Hạn chế',
    no_grade: 'Mudeunggeup',
    no: 'bất kỳ',
    security_title: 'Hạn chế tiêu chí đánh giá bảo mật cụ thể',
    banner1: 'an ninh đáng tin cậy',
    banner2:
      'Đối với việc mua hoặc bán thông qua ONETETHERERONETETHERTHER phải đảm bảo mã hóa dữ liệu, giám sát giao dịch theo thời gian thực, các chính sách bảo vệ người mua và người bán, và tất cả các khoản thanh toán của bạn thông qua một an toàn thanh toán và thanh toán chương trình nONETETHERTETHER.',
    banner_invite: 'ONETETHERER Đỗ chưa có tài khoản?',
    banner_join: 'Đăng kí miễn phí',
    banner3: 'Làm thế nào ONETETHERER là giữ khách hàng của chúng tôi an toàn',
    content1_h3: 'Bảo vệ người mua',
    content1_text:
      'Nếu người mua ohbaesong mặc hoặc thiệt hại mibaesong, ONETETHERER thể bù đắp cho tổng số tiền thanh toán, bao gồm cả vận chuyển chi phí cho các giao dịch đủ điều kiện. *',
    content2_h3: 'Bảo vệ người bán',
    content2_text:
      'Nếu bạn nhận được một khoản thanh toán trái phép hoặc khiếu nại mibaesong chống lại người bán trong việc bán có đủ điều kiện, bạn có thể nhận được toàn bộ số tiền bảo vệ. *',
    content3_h3: 'Data Encryption',
    content3_text:
      'kết nối TLS, HTTPS để giúp giữ cho các thanh toán, chìa khóa ghim các ứng dụng di động, tuân thủ PCI an toàn hơn.',
    content3_btn: 'Tuân PCI',
    content4_h3: 'Phòng chống gian lận',
    content4_text:
      'Mọi giao dịch đều được theo dõi trong thời gian thực bằng cách phân tích tài khoản và hỗ trợ của bạn để ngăn chặn hành vi gian lận và thanh toán.',
    sec_h2: 'Kiểm tra Mua',
    sec_text:
      'ONETETHERER vì giao dịch theo dõi 24 giờ một ngày, 365 ngày khi nó phát hiện một cái gì đó khác với bình thường để liên hệ với người mua sẽ yêu cầu bạn xác nhận đăng nhập hoặc mua hàng của bạn. Cũng kiểm trONETETHERTHER cho tất cả mua và bán hàng qua e-mail.',
    wran_h2: 'Nếu bạn tìm thấy một điểm đáng ngờ',
    warn_step1: 'Báo cáo.',
    warn_step1_text1:
      'Sau khi bạn xác nhận các chi tiết đã không tìm thấy một thỏa thuận đã được phê duyệt',
    warn_step1_text2: 'Báo cáo sự cố> Báo cáo hoạt động trái phép',
    warn_step1_text3: 'Nhấn vào đây hoặc liên hệ ngay lập tức ONETETHERER.',
    warn_step2: 'Kiểm tra nếu có những vấn đề khác.',
    warn_step2_text1:
      'Xem lại cài đặt hoạt động kinh doanh và tài khoản gần đây để đảm bảo rằng những chi phí bổ sung hoặc thay đổi, vui lòng báo cáo thông tin này.',
    warn_step3: 'Vui lòng thay đổi mật khẩu của bạn.',
    warn_step3_text1:
      'Bạn có thể vào cài đặt tài khoản trên menu Security. Hoặc, nếu bạn không thể đăng nhập vào tài khoản của bạn',
    warn_step3_text2: 'Login> Vấn đề khai thác gỗ',
    warn_step3_text3: 'Nhấn vào đây để có được thiết lập lại.',
    warn_btn: 'Báo cáo giao dịch trái phép',
    online_h2: 'hỗ trợ ONETETHERER an toàn hoạt động trực tuyến.',
    online_h3: 'an ninh tài khoản',
    online_text: 'Bảo vệ tài khoản của bạn với một mật khẩu an toàn cao.',
    online_btn: 'Tìm hiểu thêm',
    auth_incomplete: 'Chứng nhận không đầy đủ.',
  },
  input: {
    id: 'ID đầu vào',
    password: 'một mật khẩu đầu vào (8-32 chữ số với các ký tự đặc biệt)',
    repeat_password: 'Xác nhận mật khẩu',
    user_name: 'input Tên đăng nhập',
    email_address: 'địa chỉ đầu vào E-mail',
  },
  oauth: {
    contact_msg: 'Muốn tiếp cận với các thông tin sau trong ứng dụng {0}.',
    agree_msg:
      '{0} Bạn có đồng ý rằng quyền truy cập vào {1} `s thông tin cá nhân?',
    agree_info:
      'Các thông tin được cung cấp sẽ được sử dụng / lưu trữ trong một thời gian phục vụ cho việc xác định người sử dụng, thống kê, tài khoản liên kết CS và những thứ tương tự. thông tin cơ bản và cung cấp các mặt hàng yêu cầu là các thông tin mà phải được cung cấp để sử dụng các dịch vụ ONETETHERER.',
    agree_request: 'dịch vụ',
    agree_msg2:
      'Khi đồng ý, thông tin sẽ được quản lý theo quy định tại các Điều khoản và Điều kiện và Chính sách bảo mật của dịch vụ.',
    agree: 'đồng ý',
  },
  pay_head_foot: {
    account_management: 'Quản lý tài khoản',
    settlement_account_list: 'Danh sách tài khoản thanh toán',
    account_summary_views: 'Tóm tắt thông tin tài khoản xem',
    fund: 'quỹ',
    history: 'Lịch sử Thanh toán',
    help: 'Trợ giúp',
    qa: 'Liên hệ',
    fee: 'hoa hồng',
    secure: 'an ninh',
    go_shop: 'mua sắm',
    my_info: 'Hồ sơ của tôi',
    my_page: 'Cài đặt tài khoản',
    out: 'Đăng xuất',
    in: 'đăng nhập',
    about: 'về',
    blog: 'Blogs',
    employ: 'việc làm',
    site_map: 'Bản đồ trang web',
    developer: 'Nhà phát triển',
    partner: 'Đối tác',
    privacy_state: 'Chính sách bảo mật',
    usage: 'Quy định sử dụng',
    feed_back: 'Phản hồi',
    warn_to_consumer:
      'Thông báo cho khách hàng: người sở hữu phương tiện trả trước thanh toán ONETETHERER ONETETHERTHER không cần sự chấp thuận của Cơ quan Giám sát Tài chính Úc. Vui lòng đọc kỹ các điều khoản và điều kiện.',
  },
  continue: 'Tiếp tục',
  pay_home: {
    cocobank_title: 'ONETETHER Ngân hàng',
    platform: 'nền tảng',
    platform_rental: 'thuê nền tảng',
    cocopay_is: 'ONETETHERER là sự phát triển của doanh nghiệp',
    help: 'Giúp.',
    home_banner_1:
      'Mở rộng cơ sở khách hàng tiềm năng trên toàn thế giới, và để tạo điều kiện quản lý thanh toán,',
    home_banner_2:
      'Kinh doanh bán Protection *, và cho phép an toàn để mua sắm với 24/7 giám sát gian lận.',
    home_banner_3: 'Bạn có thể dễ dàng hơn thành công.',
    home_banner_warn:
      '* Điều khoản và điều kiện áp dụng đối với người bán bảo vệ. Vui lòng tham khảo hợp đồng của bạn để biết chi tiết về tính hợp lệ.',
    home_banner_join: 'Tham gia ngay bây giờ cho miễn phí.',
    home_sec1_openShop: 'Bạn có thể mở một cửa hàng ở ONETETHERER.',
    home_sec1_btn: 'để đối phó',
    home_sec2_h2: 'Lấy phương thức thanh toán mong muốn.',
    home_sec2_text1:
      'ONETETHERER cũng có thể nhận thanh toán trực tuyến, điện thoại di động, và thậm chí gửi email.',
    home_sec2_text2:
      'Cho dù ONETETHERER bán bất cứ nơi nào người có thể hỗ trợ thanh toán dễ dàng hơn và an toàn hơn.',
    home_sec2_online_pay: 'Thanh toán trực tuyến',
    home_sec2_online_text:
      'nút thanh toán để dễ dàng thiết lập sẵn ONETETHERER là rất tiện dụng khi nhận thanh toán bằng tiền mặt và thanh toán định kỳ, đóng góp, vv VớONETETHERTHER Checkout, khách hàng có thể thực hiện thanh toán nhanh chóng và dễ dàng hơn.',
    home_sec2_online_more: 'Xem thêm về thanh toán trực tuyến',
    home_sec2_voice_invoice: 'Hóa đơn qua email',
    home_sec2_voice_text:
      'yêu cầu e-mail dễ dàng thanh toán cho các chuyên nghiệp miễn phí hóa đơn. khách hàng nước ngoài cũng như có sẵn để khách hàng không phải là tài khoản ONETETHERER.',
    home_sec2_voice_more: 'Xem thêm về email hóa đơn',
    home_sec2_exchange_pay: 'Thanh toán trên sàn giao dịch',
    home_sec2_exchange_text:
      'Với dịch vụ ví tích hợp trên sàn giao dịch, bạn có thể nạp tiền và mua và bán tiền trên bất kỳ trao đổi nào của các công ty đối tác.',
    home_sec2_exchange_more: 'Tìm hiểu thêm về tính phí trao đổi',
    home_sec2_mobile_pay: 'Nhận thanh toán di động',
    home_sec2_mobile_text:
      'Giải pháp sẽ được tự động tối ưu hóa cho điện thoại di động. Nhận thế giới mà thậm chí dễ dàng hơn để trả thông qua các trang web di động hoặc các ứng dụng Android và iOS.',
    home_sec2_mobile_more: 'Xem thêm về thanh toán di động',
    home_sec3_h2: 'Tìm công việc nhiều hơn với các đối tác ONETETHERER tự do.',
    home_sec3_global:
      'ONETETHERER sẽ kết nối các cơ hội toàn cầu nhiều hơn với các trang web tự do hàng đầu thế giới.',
    home_sec3_btn: 'Kiểm tra ONETETHERER cho tự do',
    home_sec4_h2: 'Thật dễ dàng để bắt đầu.',
    home_sec4_banner1:
      'Tìm hiểu tất cả mọi thứ bạn cần để bắt đầu từ trung tâm kinh doanh ONETETHERER.',
    home_sec4_banner2:
      'Tham gia vào tài khoản kinh doanh và xác minh địa chỉ email của bạn',
    home_sec4_banner3: 'Chứng nhận tài khoản ngân hàng',
    home_sec4_banner4: 'Chọn giải pháp thanh toán',
    home_sec5_h2:
      'Tại sao nhiều nhà khai thác trên <br/>thế giới làm tin tưởng ONETETHERER',
    home_sec5_sub_text:
      'Bởi vì nó là một sự lựa chọn tuyệt vời. ONETETHERER bạn muốn kết nối người bán với 25 cuộc gọi đến các khách hàng ít nhất hai một trăm triệu người tại hơn 200 thị trường trên toàn thế giới.',
    home_sec5_sub_text_1: 'Bởi vì nó là một sự lựa chọn tuyệt vời.',
    home_sec5_sub_text_2:
      'ONETETHERER bạn muốn kết nối người bán với 25 cuộc gọi đến các khách hàng ít nhất hai một trăm triệu người tại hơn 200 thị trường trên toàn thế giới.',
    home_sec5_h3: 'An toàn.',
    home_sec5_h3_sub1:
      'Tự động xác định lừa đảo, 24 giờ giao dịch giám sát và chương trình bảo vệ người bán và người mua để bảo vệ doanh nghiệp của bạn và khách hàng của bạn.',
    home_sec5_h3_more: 'Xem thêm về thanh toán trực tuyến',
    home_sec5_h31: 'thế giới sử dụng.',
    home_sec5_h31_sub1:
      'Tất cả các nơi trên thế giới mà không cần phải nhập thông tin mỗi khi bạn thực hiện thanh toán nhanh chóng. Trong 203 thị trường trong 26 đồng tiền bạn có thể thanh toán qua thẻ tín dụng, thẻ ghi nợ hoặc ONETETHERER.',
    home_sec5_h31_more: 'Xem thêm về email hóa đơn',
    home_sec5_h32: 'Nhanh.',
    home_sec5_h32_sub1:
      'Trong hầu hết các trường hợp khi một khoản thanh toán của khách hàng ngay lập tức được ghi có vào tài khoản của bạn ONETETHERER. ngân hàng ghi nợ hoặc thanh toán cho các nhà cung cấp hoặc sử dụng một cách tự do trong bất kỳ nơi thanh toáONETETHERTHER càng tốt.',
    home_sec5_h32_more: 'Xem thêm về eBay bán',
    home_sec6_h2: 'cơ cấu chi phí đơn giản',
    home_sec6_sub:
      'ONETETHERER sẽ tính lệ phí chỉ khi bán hàng thực hiện. phONETETHERTHER được cố định dựa trên vị trí của khách hàng và số lượng bán hàng.',
    home_sec6_more: 'Xem thêm về lệ phí',
    home_sec7_h2: 'Cộng đồng cho Hàn Quốc bán hàng, CBT LAB',
    home_sec7_text1:
      'Viện Thương mại qua biên giới (CBT LAB) là một ONETETHERER Hàn QuốcONETETHERTHER Hàn Quốc) cộng đồng thương gia tài trợ cho nước ngoài thương mại điện tử được kích hoạt.',
    home_sec7_text2:
      'CBT LAB đang giúp các doanh nghiệp phát triển thông tin trên toàn cầu phần East Coast như các xu hướng mới nhất, mẹo và phương pháp tốt nhất.',
    home_sec7_more: 'Tìm hiểu làm thế nào để tận dụng lợi thế của CBT LAB',
    home_sec8_h2: 'Gặp gỡ đối tác lồng vào nhau ONETETHERER.',
    home_sec8_text1:
      'Cần giúp đỡ chuyên nghiệp cho kinh doanh trực tuyến của bạn?',
    home_sec8_text2:
      'Web hosting giải pháp, mua sắm giỏ hàng, giải pháp thương mại điện tử, chẳng hạn như các tác phẩm trước ONETETHERER một đối tác mua trợ giúp này doanh nghiệp của bạn.',
    home_sec8_text3:
      'Tìm ONETETHERER một đối tác cho doanh nghiệp của tôi ngay bây giờ.',
    home_sec8_more: 'nhiều đối tác',
    home_sec9_h2:
      'Trở thành một người bán toàn cầu. Điều này sẽ ONETETHERER với nhau.',
    home_sec9_h2_1: 'Trở thành một người bán toàn cầu.',
    home_sec9_h2_2: 'Điều này sẽ ONETETHERER với nhau.',
    home_sec9_btn: 'Đăng ký tài khoản ngay',
    home_learn_h2: 'Tìm hiểu thêm',
    home_learn_li1: 'Giải pháp Web thanh toán',
    home_learn_li1_1: 'Trang web tiêu chuẩn thanh toán',
    home_learn_li1_2: 'ONETETHERER Thanh toán',
    home_learn_li1_3: 'Mua trên eBay',
    home_learn_li1_4: 'Giải pháp so sánh',
    home_learn_li2: 'tiền chi khác',
    home_learn_li2_1: 'email hóa đơn ONETETHERER',
    home_learn_li2_2: 'Thương mại di động',
    home_learn_li2_3: 'Kinh doanh cho thanh toán tự động',
    home_learn_li2_4: 'ONETETHERER cho B2B',
    home_learn_li2_5: 'ONETETHERER cho tự do',
    home_learn_li3: 'thiết lập ONETETHERER và hội nhập',
    home_learn_li3_1: 'trung tâm kinh doanh ONETETHERER',
    home_learn_li3_2: 'ONETETHERER Hàn Quốc cộng đồng thương (CBT LAB)',
    home_learn_li3_3: 'Thêm ONETETHEREONETETHERTHER vào trang web',
    home_learn_li3_4: 'Kiểm tra hướng dẫn tốt nhất Set',
    home_learn_li3_5: 'Nhà phát triển',
    home_learn_li3_6: 'Đối tác',
    home_learn_li3_7: 'Làm thế nào ONETETHERER',
    home_learn_li4: 'Quản lý Tài khoản của tôi',
    home_learn_li4_1: 'ứng dụng kinh doanh ONETETHERER',
    home_learn_li4_2: 'Cài đặt Tài khoản kinh doanh',
    home_learn_li4_3: 'Chương trình Bảo vệ người bán',
    home_learn_li4_4: 'Quản lý khiếu nại của khách hàng',
    home_learn_li4_5: 'Hiểu Bồi hoàn (CB)',
    home_learn_li4_6: 'hạn chế tài khoản Hiểu',
    home_learn_li4_7: 'Gian lận phòng chống Mẹo',
    home_learn_li4_8: 'Tuân PCI',
  },
  pay_nav: {
    view_your_account: 'Xem toàn bộ tài khoản của bạn',
    account_summary_views: 'Tóm tắt thông tin tài khoản xem',
  },
  pay_login: {
    secure_sub_title: 'Đăng nhập và Bảo mật',
    secure_my_profile: 'Hồ sơ của tôi',
    secure_update_complete:
      'Hồ sơ cá nhân và các thiết lập môi trường đã được cập nhật.',
    secrue_suggest:
      'Bất cứ khi nào bạn cho chúng tôi biết kinh nghiệm của bạn.',
    search: 'hồi',
    my_info: 'Thông tin cá nhân',
    update: 'cập nhật',
    e_mail: 'E-mail',
    default: 'thông tin cơ bản',
    call: 'điện thoại',
    phone: '(Di động)',
    pay_mobile: 'Thanh toán di động',
    trading: 'Cho-và-take',
    password: 'mật khẩu',
    change: 'thay đổi',
    secure_qa: 'Câu hỏi an ninh',
    staying: 'Keep me logged in cho việc mua bán nhanh',
    edit: 'biên soạn',
    browse_manage:
      'Quản lý các thiết bị được chọn và trình duyệt để duy trì trạng thái đăng nhập.',
    account_type: 'Các loại tài khoản',
    account_delete: 'huỷ tài khoản',
    business: 'kinh doanh',
    edit_email: 'Chỉnh sửa địa chỉ email',
    change_email: 'Thay đổi Địa chỉ Email',
    update_email: 'Thêm email của bạn',
    eamil_url: 'E-mail địa chỉ',
    update_email_url: 'Thêm địa chỉ email của bạn',
    error_email: 'Xin lỗi. Giá trị mặc định e-mail không thể chỉnh sửa.',
    confirm_new_email: 'Kiểm tra các địa chỉ e-mail mới',
    change_mail: 'thay đổi email',
    confirm: 'sự xác nhận',
    changing: 'thay đổi',
    deleting: 'xóa',
    reaming:
      'Hiện tại có hai trong số những địa chỉ email liên kết với tài khoản của bạn. Bạn có thể thêm đến 5 email.',
    qa_1: 'tên của trường tham dự đầu tiên là gì?',
    qa_2: 'tên của con vật cưng đầu tiên là gì?',
    edit_phone: 'Chỉnh sửa một số điện thoại hiện có',
    korea: 'Hàn Quốc',
    explanation:
      'Bằng cách thêm số lượng, tôi xác nhận rằng bạn đồng ý để tự động quay số và nhận cuộc gọi trước ghi và văn bản tùy thuộc vào lý do cho chính quyền thêm hai con số này được mô tả trong Chính sách bảo mật. lãi suất thông thường có thể áp dụng.',
    edit_phone_num: 'Thay đổi số điện thoại',
    edit_password: 'đổi mật khẩu',
    confirm_password: 'Kiểm tra mật khẩu hiện tại của bạn',
    new_passod: 'Mật khẩu mới',
    confirm_password_new: 'Xác nhận mật khẩu mới',
    secure_question: 'Câu hỏi an ninh',
    secure_pick: 'câu hỏi trắc nghiệm',
    secure_answer: 'câu trả lời',
    edit_browse:
      'Với ONETETHERER One Touch bạn có thể nhanh chóng hoàn thành việc thanh toán mà không cần phải đăng nhập mỗi lần.',
    already_log: 'Đã đăng nhập trên máy tính này.',
    off_all: 'ONETETHERER One Touch tắt trên tất cả các thiết bị của bạn',
    support:
      'PayPal cam kết 100% sự hài lòng của khách hàng. Nếu bạn có một vấn đề với tài khoản của bạn',
    support_center: 'Hỗ trợ khách hàng',
    support_text1: 'Hoặc kiểm tra',
    support_text2: 'Vui lòng tham khảo.',
    support_warn:
      'Nếu bạn hủy tài khoản của bạn, bạn không thể hủy bỏ hồ sơ tài khoản của bạn cũng sẽ biến mất và mức độ tin cậy.',
  },
  help: {
    support_center: 'ủng hộ',
    resolution_center: 'Tranh chấp Trung tâm Nghị quyết',
    qa_search: 'Tìm kiếm câu hỏi thường gặp',
    common_qa: 'câu hỏi chung',
    common_qa_1:
      "Có gì 'Tại sao một thông báo lỗi sẽ được hiển thị sau khi cập nhật trạng thái của đơn đặt hàng thông qua quỹ Get Links?",
    common_qa_2:
      'Làm thế nào để rút tiền từ tài khoản của Triều Tiên ONETETHERER?',
    common_qa_3:
      'Làm thế nào để thêm một thẻ ghi nợ hoặc thẻ tín dụng để ONETETHERER tài khoản của tôi?',
    common_qa_4:
      'ONETETHERER Tôi quên mật khẩu tài khoản của tôi. Làm thế nào để thiết lập lại mật khẩu của tôi?',
    common_qa_5: 'Tôi có thể hủy đã gửi thanh toán lượng ONETETHERER?',
    common_qa_6: 'Làm thế nào để nhận thanh toán qua ONETETHERER?',
    common_qa_7: 'Làm thế nào để gửi Thanh toán qua ONETETHERER?',
    common_qa_8:
      'Làm thế nào để thêm một tài khoản ngân hàng vào tài khoản ONETETHERER?',
    common_qa_9:
      'Làm thế nào tôi có thể kiểm tra tài khoản ngân hàng gắn liền với ONETETHERER tài khoản của tôi?',
    common_qa_10:
      'Làm thế nào để vô hiệu hóa các giới hạn tài khoản ONETETHERER?',
    technical_support: 'Theo dõi các vấn đề kỹ thuật và cập nhật.',
    condition_cocopay: 'nhà nước Xem ONETETHERER',
    muliple_help: 'Nhiều cách để có được sự giúp đỡ',
    trading_help: 'Để giải quyết vấn đề như vậy đối phó',
    tex_center: 'Trung tâm thuế',
    tex_help: 'Tìm các hình thức thuế và các nguồn lực khác',
    need_help: 'Liên hệ',
    help_center: 'Liên hệ Hỗ trợ khách hàng',
    help_to_center: 'Liên hệ Hỗ trợ khách hàng',
    prepare: 'Sắp có.',
    fast_help:
      'Hãy cho chúng tôi vấn đề của bạn để chúng tôi có thể nhanh chóng hơn giúp ONETETHERER.',
    my_search: 'Tìm kiếm My Vấn đề',
    common_problem: 'vấn đề thường gặp',
    login_problem: 'vấn đề đăng nhập',
    unkown_charge:
      'Truy cập trái phép hoặc các khiếu nại chưa được biết báo cáo',
    send_money: 'Gửi tiền',
    get_fund: 'nhận tiền',
    withdraw_money: 'rút tiền',
    pay_cancel: 'Thanh toán hoặc hủy đơn đặt',
    pay_hold: 'Thanh toán đang chờ hoặc chờ đợi',
    refund: 'Hoàn lại tiền',
    pre_pament: 'thanh toán được chấp thuận trước',
    negative_balance: 'dư âm',
    account_qa_1:
      'ONETETHERER rút khỏi tài khoản của tôi nhà nước mặc dù nó cho thấy là "hoàn thành" Tại sao là tiền bạc mà không chứa một tài khoản ngân hàng?',
    account_qa_2:
      'là những gì lý do ONETETHERER rút của tôi vẫn là "chờ xử lý" trạng thái?',
    account_qa_3: 'Tại sao rút của tôi đang chờ?',
    item_title: 'Access Password và tài khoản',
    item_title_2: 'Hồ sơ tài khoản & Cài đặt',
  },
  business: {
    no_trade: 'Không có thị trường ngoại càng tốt.',
    view_your_account: 'Xem toàn bộ tài khoản của bạn',
    available: 'có sẵn',
    calculate_late:
      'Chúng tôi sẽ hiển thị tài sản hiện tại của điện trường CCF quan trọng nhất.',
    payment_transfe: 'chuyển thanh toán',
    exchange: 'Thu đổi ngoại tệ',
    currency_update: 'Thêm cuộc gọi',
    update_btn: 'nút dấu cộng',
    currency_cal: 'chuyển đổi ngoại tệ',
    pay_default: 'Tuỳ chọn thanh toán',
    payment_send: 'Gửi tin hoặc yêu cầu thanh toán',
    account_list: 'Danh sách tài khoản',
    no_alias: 'không bí danh',
    new_bank: 'Kết nối ngân hàng mới',
    card: 'thẻ',
    new_card: 'Kết nối thẻ mới',
    credit: 'thẻ tín dụng',
    preference_payment:
      'Chọn phương thức thanh toán trực tuyến ưa thích của bạn.',
    payment_tip:
      'Khi mua sắm trực tuyến hoặc gửi thanh toán cho hàng hóa và dịch vụ sử dụng phương tiện này. Bạn bất cứ lúc nào có thể chọn phương thức thanh toán khác nhau trong kiểm tra.',
    payment_more: 'Tìm hiểu về sở thích thanh toán của bạn',
    paymnet_changes: 'cân bằng ONETETHERER',
    debit_card: 'thẻ ghi nợ',
    currency_tip:
      'Nếu bạn thêm một đồng tiền, tất cả các khoản thanh toán trong tương lai đã nhận được bằng đồng tiền đó sẽ được ghi có vào số tiền thích hợp. Các loại tiền tệ cơ sở được sử dụng để gửi thanh toán hoặc yêu cầu thanh toán.',
    currency_1: 'Dollar Úc',
    currency_2: 'Franc Thụy Sĩ',
    currency_3: 'Cuaron Séc',
    currency_4: 'Krone Đan Mạch',
    currency_5: 'euro',
    currency_6: 'Bảng Anh',
    currency_7: 'Hồng Kông Dollar',
    currency_8: 'Đồng Forint',
    currency_9: 'Israel mới Sêken',
    currency_10: 'Peso Mexico',
    currency_11: 'Na Uy Krone',
    currency_12: 'Đôla New Zealand',
    currency_13: 'Philippine Peso',
    currency_14: 'Zloty Ba Lan',
    currency_15: 'Rúp Nga',
    currency_16: 'Thụy Điển Krona',
    currency_17: 'Đô la Singapore',
    currency_18: 'baht',
    currency_19: 'Đài Loan mới Dollars',
    withdraw_account: 'Tài khoản rút',
    exchanged: 'Sau khi trao đổi tiền tệ',
    exchange_rate: 'Tỷ giá ngoại tệ',
    exchange_tip:
      'Tỷ giá hối đoái là số tiền ước tính dựa trên tỷ giá hối đoái hiện hành, lệ phí trao đổi được bao gồm trong ONETETHERER.',
    currency_default: '(A) Đồng Yen Nhật được thiết lập để tiền tệ mặc định.',
    currency_default_notice:
      'Các loại tiền tệ cơ sở được sử dụng để gửi thanh toán hoặc yêu cầu thanh toán.',
    currency_default_notice2:
      'Kết thúc cuộc gọi không được hiển thị trên số dư không nhận được bất kỳ thanh toán cho các cuộc gọi.',
    currency_default2: 'JPY (s), mặc định',
    currency_quit_jp_btn: 'Đóng Dollars',
    currency_quit_btn: 'Đóng cuộc gọi',
    bank_account: 'tài khoản',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: 'số dư',
    bank_account_check: 'Ngân hàng xác nhận',
    bank_account_remove: 'Xóa Ngân hàng',
    bank_continue: 'Bạn có muốn tiếp tục không?',
    bank_tip:
      'Trong khi chờ các giao dịch với các ngân hàng được xử lý sau khi xóa.',
    bank_this_delete: 'Xóa Ngân hàng',
    card_tip:
      'Tài khoản ONETETHERER Muốn sử dụng nó mà không cần tốn hoặc giới hạn rút tiền?',
    card_confirm: 'Kiểm tra thẻ.',
    card_type: 'kiểu',
    expiry_date: 'hết hạn',
    card_adress: 'Địa chỉ thanh toán',
    card_update: 'thẻ Update',
    card_delete: 'thẻ Xóa',
    card_this_delete: 'thẻ Xóa',
    card_tip2:
      'phương thức thanh toán này hiện được ưa thích. Sau khi hoàn thành, bạn có thể thiết lập một phương thức thanh toán ưu đãi khác nhau. Deal đang chờ giải quyết với (a) không xác định được xử lý sau khi xóa.',
    secure_code: 'Mã bảo vệ',
  },
  shop: {
    shop_list: 'cửa hàng sách',
    shop_create: 'mua sắm tạo',
    shop_cre_date: 'thêm',
    shop_title: 'Tên cửa hàng',
    shop_id: 'cửa hàng ID',
    shop_state: 'trạng thái',
    shop_work: 'công việc',
    shop_detail: 'hơn',
    shop_retouch: 'pha lê',
    shop_settlement: 'Giải quyết danh sách tài khoản',
    shop_history: 'giao dịch',
    no_shop_list: 'Không có danh sách của cửa hàng',
  },
  merchant: {
    create: 'đăng ký cửa hàng',
    update: 'đăng ký doanh nghiệp',
    retouch: 'cửa hàng sửa đổi',
  },
  pay_legal: {
    service_usage: 'Điều khoản ONETETHERER dịch vụ',
    detail_usage:
      'Các Điều khoản và Điều kiện này sẽ áp dụng đối với khu vực châu Á-Thái Bình Dương, châu Mỹ Latin và một số nước châu Âu, Trung Đông và châu Phi sử dụng. Để xem các điều khoản và điều kiện cho các quốc gia hoặc vùng khác nhau, hãy chọn trong danh sách dưới đây.',
    nation: 'Chọn một quốc gia',
    every_consumer: 'Tất cả người dùng',
    service_agree: 'hợp đồng của bạn cho ONETETHERER Dịch vụ',
    privacy_state: 'Chính sách bảo mật',
    purpose_policy: 'Chính sách sử dụng ONETETHERER',
    payment_agreement: 'thỏa thuận phương thức thanh toán thay thế ONETETHERER',
    sell_buy: 'Merchant và Kinh doanh',
    shop_policy: 'ONETETHERER Hỗ trợ cửa hàng Chính sách',
    contract_profit: 'Hợp đồng phi lợi nhuận tập đoàn',
    billing_agreement: 'Hiệp định thanh toán',
    direct_debit_agreement: 'quỹ ONETETHERER nhận và thỏa thuận ghi nợ',
    additional_info: 'Các thông tin khác',
    infringement: 'Somyeongseo vi phạm chính sách',
    policy_update: 'chính sách cập nhật',
    warn1:
      'Thông báo cho người tiêu dùng: dịch vụ thanh toán ONETETHERER được coi như một phương tiện trả trước thanh toán (Stored Value sở) theo quy định của pháp luật Úc.',
    warn2:
      'ONETETHERER chủ sở hữu phương tiện trả trước thanh toán ONETETHERTHER không cần sự chấp thuận của Cơ quan Giám sát Tài chính Úc. Chúng tôi cũng khuyến khích người tiêu dùng (người dùng) được đọc kỹ các điều khoản và điều kiện.',
    warn3:
      'Những Điều khoản sử dụng và Thông báo cung cấp các điều khoản và điều kiện liên kết với một dịch vụ ONETETHERER cụ thể.',
  },
  pay_privacy: {
    effective_day: 'Ngày hiệu lực: 28 tháng 3 năm 2019',
    summary: 'tóm lại',
    personal_data: 'Dữ liệu cá nhân được thu thập bởi ONETETHERER',
    personal_date_cause: 'Lý do để giữ ONETETHERER dữ liệu cá nhân của bạn',
    summary_1: 'người dùng của chúng tôi là',
    summary_2: 'Sites',
    summary_3: 'hoặc ghé thăm',
    summary_4: 'dịch vụ',
    summary_5: 'Khi sử dụng của người dùng',
    summary_6: 'dữ liệu cá nhân',
    summary_7:
      'Làm thế nào để thu thập và lưu trữ, quản lý và chia sẻ, giải thích rằng việc chuyển giao đã chuẩn bị Chính sách bảo mật này. Chính sách bảo mật này áp dụng cho dữ liệu cá nhân của bạn khi ghé thăm trang web của chúng tôi hoặc sử dụng dịch vụ, ONETETHERER khác',
    summary_8: 'người sử dụng',
    summary_9:
      'Nó không áp dụng cho các trang web hoặc ONETETHERER web trực tuyến không thuộc sở hữu hoặc điều chỉnh, trong đó có trang web dịch vụ hay dịch vụ.',
    summary2_1:
      'ONETETHERER bạn có thể ghé thăm trang web của chúng tôi hoặc thu thập thông tin cá nhân khi bạn sử dụng các loại sau đây của các dịch vụ.',
    summary2_2: 'Sử dụng Up và Thông tin',
    summary2_3:
      'Khi bạn đăng ký một tài khoản để sử dụng các dịch vụ của ONETETHERER, để đáp ứng các thông tin cần thiết để thu thập dữ liệu cá nhân để cung cấp các dịch vụ theo yêu cầu của người sử dụng.',
    summary2_4:
      'Tùy thuộc vào các dịch vụ được lựa chọn, bạn có thể yêu cầu cung cấp các thông tin nhận dạng cần thiết để tạo ra một tên người dùng, địa chỉ gửi thư, số điện thoại, địa chỉ email, tài khoản.',
    summary2_5:
      'Điều khoản bạn có thể yêu cầu cung cấp thông tin cá nhân bổ sung, tùy thuộc vào dịch vụ.',
    summary3_1: 'Kinh doanh kinh nghiệm và thông tin',
    summary3_2:
      'Sử dụng các dịch vụ của ONETETHERER hoặc nếu truy cập vào trang web, ví dụ, mua từ người bán, hoặc nhận tiền hoặc nếu tiến hành thanh toán hoặc gửi tiền cho bạn bè và gia đình, thông tin giao dịch liên quan đến thu thập khác, cũng như các thông tin giao dịch tONETETHERTHER các. thông tin thương mại khác có liên quan bao gồm việc gửi hoặc yêu cầu tiền bạc, hàng hóa hoặc dịch vụ thanh toán tiền, người bán, trong đó có thông tin về tất cả các phương thức thanh toán sử dụng để điền các thông tin giao dịch và thiết bị thông tin, dữ liệu công nghệ, thông tin vị trí, và những thứ tương tự.',
    summary4_1: 'Thông tin người tham gia',
    summary4_2:
      'Khi bạn sử dụng hoặc truy cập các dịch vụ trang web ONETETHERER thu thập dữ liệu cá nhân mà người dùng cung cấp khoảng người tham gia khác tham gia vào thương vụ này.',
    summary4_3: 'Để gửi hoặc tiền yêu cầu',
    summary4_4:
      'Nếu bạn gửi hoặc yêu cầu gửi tiền qua ONETETHERER Dịch vụ thu thập tên, địa chỉ gửi thư, số điện thoại, dữ liệu cá nhân như nhận tiền từ thông tin tài khoản tài chính của bạn trong những người tham gia gửi tiền cho bạn.',
    summary4_5:
      'Phạm vi của dữ liệu cá nhân được yêu cầu liên quan đến những người tham gia có thể khác nhau tùy thuộc vào các dịch vụ sử dụng để gửi hoặc yêu cầu gửi tiền.',
    summary5_1:
      'Thanh toán cho người khác thay vì các hóa đơn hoặc hóa đơn yêu cầu thanh toán cho người khác',
    summary5_2:
      'Nếu bạn sử dụng dịch vụ ONETETHERER để yêu cầu họ thanh toán hóa đơn thay mặt cho người khác, hoặc thanh toán hóa đơn của bạn trên danh nghĩa của mình để người dùng khác, tên người dùng, địa chỉ gửi thư, số điện thoại, địa chỉ email, thanh toán người dùng thay vì các hóa đơn hoặc người khác chủ sở hữu tài khoản phải thu thập dữ liệu cá nhân có liên quan, bao gồm số tài khoản mà bạn muốn trả tiền để thay thế.',
    summary6_1: 'Nạp tiền vào tài khoản của bạn',
    summary6_1_1: 'tài khoản của bạn',
    summary6_2:
      'Để nạp tiền vào tài khoản khác trong tài khoản của người dùng hoặc người dùng có thể sở hữu, hoặc nếu bạn sử dụng dịch vụ ONETETHERER yêu cầu để được thêm vào số tiền trong tài khoản này cho người sử dụng khác ở phía bên kia từ người dùng để xử lý một cách hiệu quả yêu cầu của bạn thu thập thông tin hoặc có thể thu thập thông tin về bạn từ phía bên kia.',
    summary6_3:
      'Ví dụ, sạc hoặc bằng cách sử dụng yêu cầu dịch vụ ONETETHERER để được thêm vào số tiền trong tài khoản để một chiếc điện thoại di động, bạn có thể thu thập các thông tin khác, bao gồm cả dữ liệu cá nhân, và số tài khoản điện thoại di động từ những người tham gia khác.',
    summary7_1:
      'Thông tin liên quan đến người trên bạn bè và địa chỉ liên lạc của bạn',
    summary7_2:
      'Khi người dùng kết nối danh sách liên lạc trong tài khoản của bạn, thật dễ dàng để giúp đỡ mọi người đối phó với khi ONETETHERER với bạn bè và địa chỉ liên lạc của bạn. Vì vậy, người dùng có thể sử dụng thiết bị, hoặc thiết lập một kết nối giữa các nền tảng truyền thông xã hội hoặc các thiết bị vào tài khoảONETETHERTHER hoặc phương tiện truyền thông xã hội khi kết nối với nền tảng dịchONETETHERTETHER tốt hơn thu thập và sử dụng địa chỉ liên lạc của bạn thông tin danh sách (tên, địa chỉ, địa chỉ email, vv) ONETETHERNETETHER cải thiện môi trường.',
    summary8_1:
      'Thông tin mà bạn chọn để cung cấp ONETETHERER để sử dụng dịch vụ trực tuyến nhất định hoặc dịch vụ bổ sung',
    summary8_2:
      'Nếu yêu cầu hoặc tham gia vào việc lựa chọn các trang web với các tính năng yêu cầu hoặc dịch vụ được cải thiện, hoặc các tính năng tùy chọn khác, bạn có thể thu thập thêm thông tin về người dùng trong ONETETHERER.',
    summary8_3:
      'Nếu các phương pháp sử dụng để thu thập thông tin từ các dịch vụ khác với những quy định trong chính sách bảo mật, các thông tin thu thập trong một thông báo riêng.',
    summary9_1:
      'Thông tin cho người sử dụng khi sử dụng "ONETETHERER không thanh toán" dịch vụ',
    summary9_2:
      'Đối với một số dịch vụ hạn chế có thể cần phải đăng nhập hoặc sử dụng cài đặt tài khoản của bạn để không thanh toán. ONETETHERER sẽ thu thập dữ liệu cá nhân của bạn, tất cả các phương thức thanh toán thông tin thiết bị có liên quan, dữ liệu công nghệ, thông tin vị trí cần thiết cho người sử dụng để hoàn tất giao dịch. Khi bạn chọn chủ sở hữu tài khoản và thanh toán cho các phi thương mại, bạn có thể xây dựng và thông tin giao dịch thu thập liên quan đến tài khoản của bạn.',
    summary9_3:
      'Nếu người dùng trong khi không phải là chủ sở hữu tài khoản và chọn thanh toán cho hợp đồng không ONETETHERER, thu thập và lưu trữ tất cả thông tin mà bạn cung cấp được sử dụng và chia sẻ phù hợp với thông tin trong Chính sách bảo mật này.',
    summary10_1: 'Thông tin người dùng cụ thể thu được từ các bên thứ ba',
    summary10_2:
      'Từ một bên thứ ba, chẳng hạn như thương gia, các nhà cung cấp dữ liệu, văn phòng tín dụng ở mức độ pháp luật cho phép, bạn có thể nhận được thông tin.',
  },
  partner: {
    be_partner: 'Trở thành một đối tác của ONETETHERER.',
    banner_text:
      'Mua sắm cung cấp nền tảng, thị trường, có một nhà khai thác hỗ trợ thanh toán đòi hỏi phải có một nhà cung cấp dịch vụ thanh toán có thể là một đối tác của ONETETHERER.',
    banner_btn: 'Để liên hệ với quản lý tài khoản của bạn',
    benefit: 'lợi ích ONETETHERER rằng các đối tác được hưởng',
    benefit_1: 'Tích hợp và hỗ trợ kỹ thuật cho các giải pháp xây dựng',
    benefit_2:
      'Xin vui lòng liên hệ với nhóm hỗ trợ của chúng tôi dành cho bạn để được giúp đỡ trong hội nhập ONETETHERERONETETHERTHER cổng thông tin nhà phát triển cũng có thể được sử dụng như một nguồn tài nguyên.',
    benefit_3: 'tăng trưởng kinh doanh thông qua các cơ hội tiếp thị',
    benefit_4:
      'Hãy tận dụng nhiều cơ hội tiếp thị cung cấp ONETETHERER có thể thu hút khách hàng tiềm năng.',
    traction: 'Và kéo thanh toán trên toàn thế giới.',
    traction1:
      'đối tác ONETETHERER đang hỗ trợ một nền tảng sáng tạo cho một khu định cư mịn của người bán để tin tưởnONETETHERTHER.',
    traction_btn: 'nhiều đối tác',
    program: 'Chương trình Đối tác ONETETHERER là miễn phí để tham gia.',
    program_1:
      'Hãy điền vào mẫu trực tuyến, chúng tôi sẽ liên lạc với bạn trong ONETETHERER.',
    program_2: 'Vui lòng mô tả các giải pháp kinh doanh hoạt động và chạy.',
    program_3:
      'Hãy liên lạc ONETETHERER để thảo luận về những thay đổi cần thiết.',
    program_4:
      'ONETETHERER tích hợp với sự giúp đỡ và đảm bảo rằng họ nhậONETETHERTHER thanh toán.',
    program_btn: 'Để liên hệ với quản lý tài khoản của bạn',
    common_qa: 'Câu Hỏi Thường Gặp',
    common_qa1: 'Có bất kỳ đối tác nhà cung cấp ONETETHERER?',
    common_qa1_text:
      'đối tác ONETETHERER là B2B (doanh nghiệp với doanh nghiệp) công ty cung cấp các giải pháp khách hàng của mìnONETETHERTHONETETHERTETHER đang hợp tác với các tổ chức như giỏ mua hàng, các công ty lưu trữ web, phát triển web, các nhà cung cấp dịch vụ hậu cần và cơ quan tiếp thị kỹ thuật số, cổng thanh toán.',
    common_qa2: 'Có gì đối tác ONETETHERER đủ điều kiện?',
    common_qa2_text: 'Liên quản lý tài khoản của bạn',
    common_qa2_text_2:
      'Bạn có thể nhận được tư vấn về khả năng của các đối tác.',
    common_qa3: 'Chúng tôi cung cấp tích hợp dịch vụ hỗ trợ trong ONETETHERER?',
    common_qa3_text:
      'Sau khi đăng ký trong chương trình đối tác và ONETETHERER chính tham gia, bạn có thể truy cập các diễn đàn tài liệu và nhà phát triển tích hợp có giá trị. Nó cũng có thể nhận được hỗ trợ tích hợp cho chuyên gia tư vấn cấp Giấy chứng nhận.',
    common_qa4:
      'Ngoài ra còn có một bên ngoài doanh nghiệp của Hàn Quốc, tôi có thể đăng ký riêng cho mỗi quốc gia trong Chương trình đối tác?',
    common_qa4_text:
      'Nó phụ thuộc vào quốc gia mà bạn đang điều hành một doanh nghiệp. Trong ONETETHERER đang triển khai chuyên đại diện đối tác theo các yêu cầu khu vực ở các nước khác nhau.',
    common_qa4_more: 'Xem Chương trình đối tác cung cấp quốc gia',
  },
  pay_main: {
    total_product: 'Tổng số sản phẩm',
    total_sum: 'tập hợp',
    pay_this_account: 'Thiết lập tài khoản này như một phương thức thanh toán.',
    bill_show: 'Các thông tin giao dịch được hiển thị như sau trong đặc tả.',
    banner_text: 'ONETETHERER là an toàn hơn',
    banner_text2: 'Một thanh toán nhanh chóng.',
    banner_text3:
      'Không có vấn đề nơi mua sắm sẽ tiếp tục thông tin tài chính của bạn an toàn.',
    footer_1: 'Điều khoản và Điều kiện',
    footer_2: 'Hiệp định sử dụng',
    footer_3: 'Chính sách bảo mật',
    footer_4: 'Phản hồi',
    footer_5:
      'Thông báo cho khách hàng: người sở hữu phương tiện trả trước thanh toán ONETETHERER ONETETHERTHER không cần sự chấp thuận của Cơ quan Giám sát Tài chính Úc.',
    footer_6: 'Quy định sử dụng',
    footer_7: 'Chúng tôi cũng khuyến khích bạn đọc nó một cách cẩn thận.',
    footer_8: 'Thanh toán',
    wallet: 'E-wallet quản lý',
    last_name: 'tình dục',
    card_number: 'Số thẻ',
    three_number: 'ba chữ số',
    name: 'tên',
    pay_cocopay: 'Thanh toán bằng ONETETHERER',
    free_shipping:
      'Nếu tài khoản ONETETHERER, bạn có thể nhận được miễn phí vận chuyển trở lại, bảo vệ mua.',
    email_phone: 'Email hoặc số điện thoại',
    login_error: 'Bạn có ký rắc rối trong?',
    pay_card: 'Thanh toán bằng thẻ',
    cancel_back: 'Hủy bỏ và trở về trang trước',
  },
  site_map: {
    site_map_tip:
      'Một liên kết mà sẽ giúp bạn khám phá những tài khoản ONETETHERER.',
    map_fund: 'quỹ',
    map_fund_1: 'ghi nợ',
    map_fund_2: 'khả năng của mình để sử dụng số dư là?',
    map_fund_3: 'Gửi tin hoặc yêu cầu gửi tiền',
    map_fund_4: 'Quản lý cuộc gọi',
    map_fund_5: 'ONETETHERER giảm giá thẻ ghi nợ của tôi',
    map_fund_6: 'Nhận thẻ ghi nợ ONETETHERER',
    map_fund_7: 'Lịch trình thanh toán ONETETHERER tín dụng',
    map_deal: 'nhiều',
    map_deal_1: 'Xem tất cả các hoạt động giao dịch',
    map_deal_2: 'quan điểm hoạt động (bao gồm cả cân bằng và lệ phí)',
    map_deal_3: 'đồ thị và biểu đồ Xem Deal',
    map_deal_4: 'Tải về Deal',
    map_deal_5: 'Để đối phó với yêu cầu bồi thường hoặc chargeback',
    map_deal_6: 'IPN (ngay lập tức thông báo thanh toán) Lịch sử',
    map_profile: 'Hồ sơ and Settings của tôi',
    map_profile_1: 'gương kinh doanh',
    map_profile_2: 'Email, địa chỉ, điện thoại hoặc Cập nhật mật khẩu',
    map_profile_3: 'Tài khoản ngân hàng hoặc cập nhật thẻ',
    map_profile_4: 'cập nhật Notifications',
    map_profile_5: 'Giới hạn Xem tài khoản',
    map_profile_6: 'Quản lý người dùng',
    map_profile_7: 'Giao hàng Cập nhật Preferences',
    map_support: 'ủng hộ',
    map_support_1: 'Đến Trung tâm Giải quyết tranh chấp',
    map_support_2: 'Tới Trung Tâm Hỗ Trợ',
    map_support_3: 'Liên hệ',
    map_support_4: 'thông tin phí thương ONETETHERER',
    map_report: 'báo cáo',
    map_report_1: 'Báo cáo thành lập, quản lý hoặc tải về',
    map_manage: 'Công cụ',
    map_manage_1: 'Xem công cụ',
    map_manage_2: 'quản lý nút ONETETHERER',
    map_manage_3: 'Quản lý thanh toán thường xuyên',
    map_consum: 'khách hàng',
    map_consum_1: 'View Guest Danh sách',
  },
  fee: {
    fee_tip: 'Cấu trúc đơn giản Phí',
    fee_banner_1:
      'Nói chung, mua là miễn phí và có thể phải chịu phí dịch vụ đổi tiền.',
    fee_banner_2:
      'Nếu bán hàng không gắn bó với lệ phí hàng tháng ONETETHERER, hoặc phí hủy. Sau mỗi lần hoa hồng sẽ chỉ được thanh toán.',
    fee_h2: 'Thông thường mua là miễn phí.',
    fee_text1: 'Phí chuyển tiền xử lý được trả bởi người bán.',
    fee_text2: 'Tuy nhiên, bạn có thể trao đổi lệ phí được áp dụng.',
    fee_more: 'phí bán tìm hiểu thêm',
    fee_text3:
      'Bán theo hóa đơn hoặc thanh toán Email trang Web (giá tiêu chuẩn thanh toán quốc tế được áp dụng)',
    fee_text4: 'Một khoản phí cố định dựa trên việc tiếp nhận các cuộc gọi',
    fee_text5: 'lệ phí trao đổi có thể áp dụng thêm.',
    fee_text6:
      'Ví dụ, đối với một biên nhận thanh toán lệ phí cố định bằng USD đó là $ 0.30 USD.',
  },
  dash: {
    more: 'hơn',
    withdraw_asset: 'rút vốn',
    currency: 'ngoại tệ',
    quotes: 'Hoá đơn và ước tính',
    last_6_months: 'Bài 6 tháng',
    make_invoice: 'thế hệ Invoice',
    manage_invoice: 'Quản lý hóa đơn',
    grown_up: 'Xin vui lòng gửi để phát triển kinh doanh cho một báo giá.',
    un_paid_invocie: 'hoá đơn chưa',
    make_quotes: 'thế hệ Quote',
    quotes_1: 'Một đã đề nghị bất kỳ hoá đơn chưa trả.',
    quotes_2: 'ONETETHERER hóa đơn',
    quotes_alarm: 'Gửi nhắc nhở',
    quotes_detail: 'Hiển thị thêm',
    quotes_who: 'Bill: Choi, Vì vậy, - Young',
    latest_act: 'Hoạt động gần đây',
    act: 'hoạt động',
    received: 'Số tiền đã nhận',
    send: 'từ thanh toán',
    act_record: 'Hoạt động (bao gồm cả cân bằng và lệ phí)',
    pay_person: 'người Biller',
    show_all: 'Xem tất cả',
    tell_us: 'Hãy cho chúng tôi biết ý kiến ​​của bạn.',
    feed_text:
      'Hãy dành một chút thời gian để cho chúng tôi biết ý kiến ​​của bạn về các thông tin hiển thị thiết kế mới trên trang này. Cảm ơn bạn!',
    service: 'cung cấp thông tin phản hồi',
    feed_text_back:
      'Cảm ơn bạn đã bình luận của bạn! Đây có cách trang web của chúng tôi là hữu ích?',
    feed_placeholder:
      'Xin vui lòng cho tôi biết lý do tôi đến ngày hôm nay ONETETHERER có một cách tốt hơn. Không bao gồm thông tin cá nhân, chẳng hạn như email hoặc số tài khoản.',
    feed_p:
      'nhân viên văn phòng ONETETHERER và khách hàng để bình luận của bạn có thể được đăng trong nội bộ, vì vậy bạn có thể nhìn thấy nó, không để lại bất kỳ thông tin cá nhân. các vấn đề dịch vụ khách hàng, xin vui lòng bấm vào đây. củONETETHERTHER',
    feed_protect: 'Chính sách bảo mật',
    feed_law: 'Điều kiện pháp lý',
    feed_or: 'và',
    feed_need: 'thấy',
    trade_name: 'tên giao dịch',
    trade_id: 'ID thỏa thuận',
    transaction_type: 'Deal Loại',
    trade_amount: 'Thanh toán',
    detail_show: 'Look',
  },
  shop_detail: {
    detail_info: 'Chi tiết cửa hàng',
    api_signature: 'chìa khóa ký cửa hàng',
    msg_shop_create: 'Cửa hàng này đã được đăng ký.',
    msg_shop_modify: 'Cửa hàng này đã được sửa.',
  },
  merchant_account: {
    create_account: 'Tạo Tài khoản thanh toán',
    enroll_account: 'Tài khoản thanh toán đăng ký',
    pls_select_account: 'Chọn Tài khoản thanh toán',
  },
  transaction_detail: {
    transaction_title: 'chi tiết Deal',
    order_id: 'Cửa hàng theo thứ tự Số',
    pay_account_title: 'Thanh toán Account Name',
    pay_account_number: 'Số tài khoản thanh toán',
    pay_account_balance: 'Số dư tài khoản thanh toán',
    pay_account_selection: 'Chọn một tài khoản để thanh toán.',
    pay_account_selection_msg: 'Vui lòng chọn một tài khoản thanh toán.',
  },
  guide: {
    guide_title_1: 'Tài khoản ngân hàng Coco.',
    guide_title_2:
      'Chuyển khoản và chuyển tiền của ngân hàng Coco như thế nào?',
    guide_title_3:
      'Tận dụng dịch vụ thuận tiện và an toàn hơn thông qua tài khoản của Coco Bank.',
    guide_strapline_1:
      'Tài khoản có thể được gỡ bỏ ngay lập tức mà không có phí',
    guide_strapline_2: 'Dễ dàng mở tài khoản nhanh một cách dễ dàng',
    guide_strapline_3: 'Vestigate.',
    guide_strapline_4: 'chuyển tiền',
    guide_strapline_5: 'Tài khoản có thể gửi nhiều loại tiền nhất ở Hàn Quốc',
    guide_strapline_6: 'Tài khoản an toàn từ hack',
    guide_strapline_7: 'Yêu cầu lịch sử trực quan và nhận có sẵn',
    guide_strapline_8:
      'Có thể được sử dụng như một tài khoản thanh toán của công ty',
    guide_strapline_9:
      'Giao dịch nhanh thông qua các tài khoản cho các giao dịch C2C và B2C',
    guide_strapline_msg_1:
      'Chuyển khoản tài khoản của Coco Bank không xảy ra để chuyển tiền.',
    guide_strapline_msg_3: 'Mở tài khoản của Coco Bank là 10 giây.',
    guide_strapline_msg_4: 'Quá trình phức tạp bị bỏ qua.',
    guide_strapline_msg_5: 'Bạn chỉ có thể tạo tên tài khoản cho tài sản đó.',
    guide_strapline_msg_6: 'Chuyển qua ví.',
    guide_strapline_msg_7: 'Sử dụng địa chỉ ví',
    guide_strapline_msg_8: 'Phí phí',
    guide_strapline_msg_9: 'Chuyển tiền trong ngân hàngco',
    guide_strapline_msg_10: 'Sử dụng số tài khoản',
    guide_strapline_msg_11: 'Phí số không',
    guide_strapline_msg_12:
      'Nhiều loại tích lũy mật mã đang được phát hành trên toàn thế giới. Coco Bank đang giao dịch với nhiều tích lũy mật mã để giúp khách hàng thuận tiện theo những thay đổi này.',
    guide_strapline_msg_13:
      'Bảo mật là cốt lõi của bao gồm mật mã. Coco Bank nghĩ rằng an ninh quan trọng nhất và các kỹ sư kỹ thuật số với hơn năm năm kinh nghiệm trong mỗi lĩnh vực đã thiết lập một hệ thống bảo mật.',
    guide_strapline_msg_14:
      'Bạn có thể truy vấn việc chuyển giữa các tài khoản. Tài khoản của Coco Bank có thể kiểm tra các ngân hàng giữa các ngân hàng hoặc các ngân hàng khác, chẳng hạn như các ngân hàng thị trường. Nếu cần thiết, bạn có thể truy cập điểm và kiểm tra và đầu ra lịch sử phát hành.',
    guide_strapline_msg_15:
      'Tài khoản của Coco Bank được liên kết với tài khoản thanh toán và thanh toán của Chợco. Sau khi đăng ký tài khoản mật mã mục tiêu dưới dạng tài khoản giải quyết, bạn có thể giải quyết hàng hóa được bán trong Chợco để một loại tiền điện tử.',
    guide_strapline_msg_16:
      'Lệ phí và sự chậm trễ xảy ra trên giao dịch giữa cá nhân thông qua ví. Coco Bank cung cấp chuyển tiền tài khoản ngân hàng Coco như một cách để giải quyết vấn đề này. Trải nghiệm các giao dịch C2C và B2C mà không phải trả phí và trì hoãn thông qua tài khoản của Coco Bank.',
  },
  account_transfer: {
    transfer: 'Chuyển tài khoản',
    transfer_list: 'lịch sử chuyển',
    transfer_list_title: 'Chuyển khoản tài khoản ngân hàng COCO',
    transfer_list_wallet: 'Chuyển ví khác',
    msg_required_data: 'Vui lòng nhập tất cả các giá trị',
    msg_not_select_withdraw_account: 'Vui lòng chọn tài khoản thanh toán',
    create_transfer_title: 'Chuyển tài khoản',
    from_account_select: 'Chọn tài khoản thanh toán',
    available_transfer: 'lượng chuyển',
    to_account_input: 'Chuyển nhập số tài khoản',
    to_account_confirm: 'Chuyển Xác minh tài khoản',
    to_account_user_name: 'Chuyển khoản Tên thành viên',
    transfer_amount: 'chuyển Số tiền',
    delete_amount: 'Correction',
    all_amount: 'đẦY ĐỦ',
    description: 'giải thích',
    transfer_btn: 'chuyển',
    transfer_info_check: 'Kiểm tra thông tin yêu cầu chuyển',
    from_account_number: 'Số tài khoản rút',
    from_asset_title: 'Tài sản Tài khoản rút',
    to_account_number: 'Chuyển Số tài khoản',
    success_transfer: 'Chuyển giao đã được xử lý thành công.',
    transfer_list_detail: 'Lịch sử chuyển nhượng &',
    search_transfer_asset: 'Tìm theo bất động sản',
    search_transfer_account: 'Tìm kiếm bằng tài khoản',
    reset: 'khởi',
    search: 'hồi',
    transfer_list_detail_tit: 'Chuyển Chi tiết Chi tiết',
    no_transfer: 'Không có chi tiết chuyển',
    msg_not_search_account:
      'Số tài khoản không tồn tại hoặc không phải là đầu vào hợp lệ.',
    my_account_transfer: 'chuyển tài khoản của tôi',
    msg_pls_select_account: 'Sau khi chọn một tài sản, tìm kiếm tài khoản.',
    placeholder_amount: 'Vui lòng nhập số tiền chuyển',
    not_search_user_name: 'Không chắc Tên truy nhập',
    msg_select_asset_search: 'Vui lòng chọn một tài khoản',
    success_fail: 'Việc chuyển nhượng không thành công.',
    pls_search_asset: 'Tìm kiếm tài sản.',
    pls_search_account: 'Tìm kiếm tài khoản của bạn.',
    pls_select_asset: 'Vui lòng chọn một tài sản.',
    not_exist_account: 'Tài khoản của tài sản không tồn tại.',
    no_inquiry_history: 'Không có lịch sử điều tra.',
    account_number_list_1: '6 tháng trước Nợ không thể được truy vấn.',
    account_number_list_2: 'Số lượt xem tối đa là 6 tháng.',
    account_number_list_3:
      'Trình bày kết quả chuyển nhượng hiện tại là một trang truy vấn các yêu cầu và chuyển đổi thương gia trong Ngân hàng Coco. <br /> Nếu bạn muốn xem kết quả chuyển giao với các ví khác, vui lòng kiểm tra đầu trang [Chuyển tiền] trên đầu trang.',
    account_number_list_3_1:
      'Truy vấn kết quả chuyển khoản hiện tại là trang dành cho các yêu cầu trong Cocobank và kết quả chuyển khoản của các cửa hàng liên kết. <br/> Nếu bạn muốn kiểm tra kết quả chuyển khoản vào tài khoản ONETETHERER của mình, vui lòng kiểm tra [chuyển khoản tài khoảONETETHERTHER] ở trên cùng',
    today: 'Ngày',
    one_week: '1 tuần',
    one_month: '1 tháng ',
    three_months: '3 tháng',
    six_months: '6 tháng',
    withdrawal_account_number: 'Số tài khoản rút tiền',
    recent_order: 'Trong đơn đặt hàng gần đây nhất',
    past_order: 'Theo thứ tự trước đây',
  },
  bank_service_center: {
    title: 'vấn đề',
    date: 'ngày',
    state: 'trạng thái',
    enter_search_word: 'Nhập thuật ngữ tìm kiếm của bạn',
    list: 'danh sách',
  },
  service_center: {
    view_all: 'Xem tất cả',
    contact_history: 'Lịch sử điều tra',
    privacy_Statement: 'Chính sách bảo mật',
    would_you_agree: 'Bạn có muốn đồng ý với những điều trên?',
    mobile_number: 'Số điện thoại di động',
    target_of_inquiry: 'Đối tượng điều tra',
    inquiry_contents: 'Nội dung điều tra',
    please_enter_your_inquiry: 'Vui lòng nhập yêu cầu của bạn.',
    send: 'Gửi',
    normal_inquiries_received: 'Yêu cầu của bạn đã được nhận thành công.',
    inquiry_history: 'Lịch sử điều tra',
    pls_select_inquiry_type: 'Vui lòng chọn loại xúc',
    pls_login_to_use_inquiry: '1, Đăng nhập vào yêu cầu đầu tiên.',
    non_member_login: 'Đăng nhập không phải thành viên',
    contact_id: 'Liên hệ với ID',
    view_inquiry: 'Xem tiếp xúc',
    service_center: 'Dịch vụ khách hàng',
    inquiry_details: 'Chi tiết liên lạc',
    msg_enter_title: 'Vui lòng nhập tiêu đề.',
    msg_enter_your_content: 'Vui lòng nhập thông tin của bạn.',
    msg_pls_login: 'Hãy đăng nhập.',
    go_back: 'trở lại',
    re_contact: 'Liên hệ Vật liệu',
    contents: 'Nội dung',
    msg_no_inquiry_history: 'Không có chi tiết liên lạc.',
    msg_require_login_additional_authentication:
      'Bạn cần phải đăng nhập hoặc xác thực bổ sung.',
    when_you_member: 'Khi một thành viên',
    msg_inquiry_history_can_view_after_login:
      'Các thành viên của chi tiết liên lạc có thể được xem sau khi đăng nhập.',
    non_member: 'Khi không phải là thành viên',
    lookup_inquiry: 'Liên Lookup',
    msg_enter_inquiry_id: 'Vui lòng nhập ID xúc.',
    msg_enter_password_when_registering_your_inquiry:
      'Vui lòng nhập mật khẩu mà bạn thiết lập khi bạn gọi đăng ký.',
    frequently_asked_questions: 'Câu Hỏi Thường Gặp',
    msg_enter_your_password: 'Vui lòng nhập mật khẩu của bạn.',
    pls_search_fap: 'Vui lòng tìm kiếm câu hỏi.',
    msg_source_filename_none: 'Không có hình ảnh đính kèm.',
    super_inquiry: 'Hàng đầu',
  },
  modal: {
    not_seeing_day: 'Không tìm kiếm một ngày',
  },
  login_guide_modal: {
    title: 'hướng dẫn',
    sub_title:
      'Để tạo điều kiện trao đổi của việc sử dụng dấu hiệu của bạn sẽ làm cho hệ thống cải cách.',
    content:
      '[Trước khi thay đổi] <br/> đầu tiên ID đăng nhập tạo ra khi bạn đăng ký <br/><br/> [sau khi thay đổi]  <br/> được sử dụng để thay đổi số điện thoại hoặc e-mail đăng nhập <br/> <br/> đăng nhập trước khi hệ thống được tổ chức lại làm thế nào đăng nhập như haejusimyeon nộp bằng văn bản ID gia nhập đầu tiên.',
  },
  affiliate: {
    affiliate_occur_list: 'Lịch sử trợ cấp',
    affiliate_adjust_list: 'Chi tiết giải quyết trợ cấp',
    allowance_balance_asset: 'Số dư trợ cấp theo tài sản',
    list_allowance_balance_asset: 'Danh sách số dư trợ cấp theo tài sản',
    search_by_asset: 'Tìm kiếm theo tài sản',
    allowance_search: 'Trợ cấp tìm kiếm',
    generator: 'Máy phát điện',
    beneficiary: 'người thụ hưởng',
    benefactor: 'ân nhân',
    behavior_type: 'Kiểu hành vi',
    target_unique_number: 'Số duy nhất mục tiêu',
    date_of_occurrence: 'Ngày xảy ra',
    application_policy_name: 'Tên chính sách ứng dụng',
    beneficiary_type: 'Loại người thụ hưởng',
    benefactor_type: 'Loại ân nhân',
    target_amount: 'Số lượng mục tiêu',
    principal_amount: 'Số tiền gốc',
    allowance: 'trả thêm',
    allowance_assets: 'Tài sản phụ cấp',
    allowance_amount: 'Số tiền trợ cấp',
    affiliate_log: 'Phân chia trợ cấp',
    allowance_settlement: 'Giải quyết phụ cấp',
    allowance_settlement_info: 'Thông tin giải quyết trợ cấp',
    name_asset_settled: 'Tên tài sản sẽ được giải quyết',
    balance_receive_payment: 'Số dư phải trả',
    select_account_settled: 'Chọn tài khoản để giải quyết',
    no_affiliate_log: 'Không có phụ cấp phát sinh.',
    no_affiliate_balance: 'Không có danh sách số dư trợ cấp theo tài sản.',
    no_affiliate_adjust: 'Không có lịch sử thanh toán phụ cấp.',
    asset_name: 'Tên tài sản',
    asset_code: 'Mã tài sản',
    balance: 'thăng bằng',
    cumulative_amount: 'Số tiền tích lũy',
    please_select_account: 'Vui lòng chọn một tài khoản',
    calculate: 'tính toán',
    settle: 'Định cư',
    calculate_amount: 'Số tiền thanh toán',
    account_number: 'Số tài khoản',
    registration_date: 'Ngày đăng kí',
    number: 'con số',
  },
  coin_name: 'Tên tiền',
  main_function: 'Chức năng chính',
  disclosure_ing: 'Trong lúc đó',
  quick_service: 'Sự phục vụ nhanh chóng',
  new_account: 'tài khoản mới',
  social_login: 'Đăng nhập xã hội',
  way_to_find: 'cách để tìm',
  cocobank_korea_head_office: 'quan điểm giao dịch',
  cocobank_branch_office: 'ONETETHERER chi nhánh Shinsa',
  address_head_office: '528 Eonju-ro, Gangnam-gu, Seoul',
  address_branch_office: '803 Nonhyeon-ro, Gangnam-gu, Seoul',
  map: 'vẽ bản đồ',
  korean_language_counseling: 'Tư vấn tiếng Hàn',
  hours_of_business:
    '10:00 đến 19:00 tại Hàn Quốc (không kể ngày nghỉ ngân hàng)',
  overseas_consultation: 'tham vấn ở nước ngoài',
  email_consultation: 'Tư vấn qua Email',

  exchange_price: 'Trao đổi tiền tệ/giá cả',
  market_price_check: 'Kiểm tra giá thị trường',
  full_account_inquiry: 'Cuộc điều tra toàn bộ',
  exchange_details_check: 'Kiểm tra chi tiết tiền tệ',
  cryptocurrency_exchange_history: 'Lịch sử trao đổi tiền tệ',
  deposit_account_inquiry: 'Điều tra tài khoản tiền gửi',
  dormant_account_check: 'Kiểm tra tài khoản không trọn vẹn',
  account_and_other_case_status:
    'Kiểm tra tài khoản ONETETHERER và các trường hợp khác.',
  account_and_other_wallet: 'Tài khoản Cocobank và các truy vấn ví khác',
  account_search: 'Truy vấn tài khoản ONETETHERER',
  other_wallet_search: 'Chuyển giao khác',
  error_remittance: 'Đồng ý trả lại tiền gửi lỗi trong ONETETHERER',
  transfer: 'Chuyển nhượng',
  transfer_result_check: 'Kiểm tra kết quả chuyển nhượng',
  other_wallets_transfer: 'Kiểm tra các kết quả khác của ví tiền/chuyển giao',
  other_wallets_transfer_search: 'Tra cứu chuyển đổi ví khác',
  frequently_used_accounts:
    'Đăng ký/quản lý các tài khoản thường xuyên sử dụng',
  new_demand_account: 'Tài khoản đòi hỏi mới',
  new_installment_savings_account: 'Tài khoản tiết kiệm trả góp mới',
  new_deposit_account: 'Tài khoản tiền gửi kỳ hạn',
  check_account_progress_account:
    'Kiểm tra tình trạng tiến độ tài khoản mới của tài khoản',
  download: 'Tải xuống',
  withdrawal: 'rút tiền',
  Smart_window_withdrawal: 'Thu hồi cửa sổ thông minh',
  smart_ATM_withdrawal: 'Rút tiền từ máy ATM thông minh',
  customer_service: 'Dịch vụ khách hàng',
  notice: 'để ý',
  one_one_inquiry: 'Cuộc điều tra một đối một',
  inquiry_details: 'Chi tiết điều tra',
  frequently_asked_questions: 'Những câu hỏi thường xuyên được hỏi',
  server_notice: 'Thông báo về máy chủ',

  service_hours: 'Thời gian vận hành dịch vụ thỏa mãn khách hàng',
  all_day_long: '(Chỉ cần liên lạc 24 tiếng là được)',
  online_service_hours: 'Khi nào sử dụng Cocobank trực tuyến',
  unusable_hours:
    '24 giờ một ngày, 7 ngày một tuần (23: 30 - 24: 00 không khả dụng)',
  offline_hours: 'Thời gian ngân hàng ngoại tuyến',
  offline_bank_hours: '(trừ cuối tuần và ngày lễ)',

  management: 'sự quản lý',
  secure_management: 'quản lý an toàn',
  fund_limit_management: 'quản lý giới hạn quỹ',
  issue_details_check: 'kiểm tra chi tiết vấn đề',
  part_of_news: 'Đây là một phần của tin tức.',
  part_of_notice: 'Đây là một phần của thông báo.',
  full_menu: 'Thực đơn đầy đủ',
  individual: 'cá nhân',
  key_coin:
    'Đồng tiền quan trọng của Ngân hàng ONETETHER kết nối tiền điện tử với tiền tệ thực',
  limitation_info:
    'Thông tin về các hạn chế giới hạn để ngăn ngừa thiệt hại do gian lận tài chính viễn thông',
  limitation_info_1:
    'Vì tài khoản thanh toán không kỳ hạn được mở không trực tiếp, giới hạn rút tiền (chuyển) thông qua thiết bị tự động và Internet được giới hạn ở {0} CCF mỗi ngày.',
  limitation_info_2:
    'Dữ liệu xác thực khách quan để xác nhận mục đích giao dịch có thể được xuất trình cho chi nhánh và giới hạn có thể được nâng lên trong “Quản lý> Xác thực / Quản lý bảo mật”.',
  limitation_info_3:
    'Khi sử dụng Internet banking, bạn phải đăng ký tài khoản rút tiền để thực hiện giao dịch chuyển khoản.',
  limitation_info_4: 'Chỉ có thể mở 5 tài khoản cho mỗi giới hạn tiền điện tử.',
  limitation_notice: 'Để ý',
  limitation_notice_1:
    'Đăng ký ngân hàng trực tuyến có thể được áp dụng bằng cách liên kết từ màn hình hoàn tất sau khi mở tài khoản gửi và rút tiền.',
  limitation_notice_2:
    'Xin lưu ý rằng khách hàng sử dụng dịch vụ Internet banking hiện tại chỉ có thể đăng ký tài khoản rút tiền qua Internet banking khi danh mục đăng ký tài khoản rút tiền là Internet + chi nhánh.',
  limitation_notice_3:
    'Bạn phải được xác thực an toàn để đảm bảo rằng bạn dễ dàng tiến hành chuyển khoản đến Internet Banking. Sau quá trình chứng nhận, vui lòng cải thiện xếp hạng và tiến hành kế toán và sắp xếp hệ thống kế toán.',
  new_subscription: 'Đăng kí mới',
  new_subscription1_1:
    'Khi bạn nhấp vào nút đăng ký mới, bạn sẽ được cấp tài khoản ',
  new_subscription1_2:
    'ONETETHERER của riêng mình và địa chỉ gửi tiền được liên kết với ví bên ngoài.',
  new_subscription2_1:
    'Hãy chắc chắn để biết trước khi gửi tiền! Không có phí nếu bạn chuyển tiền từ tài khoản dành riêng cho ONETETHERER vào tài khoản của mình. Chỉ ',
  new_subscription2_2:
    'mới có thể được gửi vào tài khoản / địa chỉ được cấp khi đăng ký mới. Bất kỳ lỗi / mất mát nào có thể xảy ra nếu bạn cố gắng gửi các tài sản kỹ thuật số khác vào địa chỉ là không thể khôi phục được. Sau khi 1 xác nhận xảy ra, nó được phản ánh vào số dư thông qua quá trình gửi tiền. Quá trình gửi tiền là tự động và thời gian cần thiết có thể thay đổi tùy thuộc vào điều kiện mạng. Địa chỉ trên chỉ là để ký gửi.',
  new_subscription3_1: 'Bạn có thể gửi ',
  new_subscription3_2: 'với một đăng ký mới được chỉ định cho bạn.',
  new_subscription4: 'Bạn đã đồng ý và hiểu những điều trên?',

  created_account_number: 'Số tài khoản đã tạo',
  cocobank_exclusive_account: 'ONETETHERER Số tài khoản chuyên dụng',
  depositing_external_wallet: 'Khi gửi tiền vào ONETETHERER từ ví bên ngoài',
  use: 'Để sử dụng',
  we_future: 'tương lai của chúng ta',
  pop_cocobank: 'NGÂN HÀNG COCO',
  fourth_industry: 'Dẫn đầu trong ngành thứ tư',
  oc_15: 'Ngày 15 tháng 10',
  officially_open: 'Mở bán chính thức!',
  head_branch_office:
    'Trụ sở chính tại Hàn Quốc (Chi nhánh Jamsil) / Chi nhánh thứ nhất (Chi nhánh Sinsa)',
  sep_15: 'Ngày 15 tháng 9 lúc 5 giờ chiều',
  open_popup: 'Mở',
  thanks_for: 'Cảm ơn bạn đã động viên của bạn.',

  direct_exchange: {
    sell_buy_assets: 'Tài sản được bán và mua',
    replace_assets: 'Nội dung được thay thế',
    ccm_exchange_rate: 'CCM giữ tỷ giá hối đoái ưu đãi',
    buy_sell_percent: 'Mua -10% Bán + 10%',
    expected_property: 'Tài sản mong đợi',
    preferential_property: 'Nội dung ưu tiên',
  },

  event_banner: {
    clap:
      'Giữ chỗ ở mã hóa với ONETETHER <span class="color-common">CLAP</span>.',
    month_hotcoupon: 'Kiểm tra phiếu giảm giá HOT của tháng này.',
    hotcoupon_sub:
      'Từ tỷ giá hối đoái đến các phiếu giảm giá liên kết khác nhau!',
    grab_bug: 'Bắt lỗi',
    grab_bug_sub:
      'Vui lòng để lại câu hỏi 1: 1. Giải thưởng được trao thông qua xổ số.',
    event2_sub_title: 'Tỷ lệ cao hơn.<br>Lợi nhuận thậm chí cao hơn.',
    event2_title: '',
    event2_text: 'Trở thành thành viên của CCM và nhận cổ tức!',
    event2_btn: 'Đăng ký',
  },
  news_lists: {
    news_list_1:
      '프라비코, iq옵션과 같은 방대한 트렌젝션을 일으키는 거래소가 될 것',
    news_list_2:
      'GCC 코인 10월 15일 포블게이트에 상장. 비트코인처럼 안정화 된 코인이 목표',
    news_list_3: '프라비코, 의료산업에 블록체인 기술 접목한다',
    news_list_4: '디파이 열풍! 그 명과 암',
    news_list_5:
      '은행을 대체할 수 있을까? 블록체인 보관과 검증은 어떻게 이루어지나',
    news_list_6: '블록체인은 식품 유통에 혁신적인 발전을 가져올 것이다',
    news_list_7: '가장 혁명적인 화폐 비트코인 탄생 배경은?',
  },
  pop_notice: {
    notice_close: 'đóng',
    notice_today: 'Hôm nay không gặp',
  },
  clap: {
    getting_started_clap: 'Phương pháp thiết lập ban đầu',
    how_to_initialize_clap: 'Cách đặt lại',
    getting_started_ledger_live: 'Cách thiết lập Ledger Live',
    install_coin_app: 'Liên kết ứng dụng tiền xu',
    start_text_1:
      '1. Sau khi kết nối CLAP và đầu nối USB kèm theo với máy tính, hãy kiểm tra cụm từ "Chào mừng" để xác nhận rằng đó là một sản phẩm mới.',
    start_text_2:
      '2. Nhấn nút bên phải và khi thông báo "Set up as new device" xuất hiện, nhấn cùng lúc hai nút trên cùng.',
    start_text_3:
      '3. Sau khi xác nhận cụm từ “Chọn mã PIN”, màn hình nhập mã PIN gồm 8 chữ số sẽ xuất hiện. Nhấn cả hai nút để đặt mã PIN.',
    start_text_4:
      '4. Khi hoàn tất cài đặt mã PIN, thông báo Xác nhận mã PIN sẽ xuất hiện. Nhập lại mã PIN bằng cách nhấn cả hai nút.',
    start_text_5:
      '5. Khi cài đặt mã PIN hoàn tất, hãy nhấn nút bên phải để hiển thị cụm từ đầu tiên trong số 24 cụm từ. Viết mã ở mặt sau của Thẻ khôi phục quan trọng theo số trên màn hình.',
    start_text_6:
      '6. Khi viết xong, hãy nhập mã khôi phục từ 1 đến 24 khớp với từng số một.',
    start_text_7:
      '7. Khi thông báo Nhấn cả hai nút để tiếp tục xuất hiện, nhấn cả hai nút ở trên cùng để tiếp tục.',
    init_text_1:
      '1. Trước khi khởi tạo, trước tiên hãy kiểm tra xem bạn có thẻ khôi phục quan trọng và mã khôi phục hay không.',
    init_text_2:
      '2. Có hai cách để khởi tạo. Đầu tiên, nếu CLAP được kết nối với PC và mã PIN không chính xác 3 lần liên tiếp, nó sẽ tự động được khởi tạo.',
    init_text_3:
      '3. Thứ hai, kết nối CLAP với PC và nhập mã PIN để mở khóa. Sau đó đi tới Cài đặt> Bảo mật> Đặt lại Tất cả theo thứ tự.',
    init_text_4:
      '4. Nhấn Reset All lần nữa trong số Cancel và Reset All để tiếp tục khởi tạo.',
    init_text_5: '5. Nhập mã PIN để hoàn tất quá trình khởi tạo.',
    init_text_6: '6. Khởi tạo hoàn tất.',
    ledger_live_text_1:
      '1. Nhập start.ledgerwallet.com vào thanh địa chỉ Internet.',
    ledger_live_text_2:
      '2. Nhấp vào ứng dụng Ledger Live ở Bước 1 để cài đặt ứng dụng cho điện thoại di động hoặc PC của bạn.',
    ledger_live_text_3:
      '3. Khi thông báo Chào mừng đến với Ledger Live xuất hiện, hãy nhấp vào Bắt đầu để tiếp tục.',
    ledger_live_text_4:
      '4. Bạn sẽ được trình bày với 4 lựa chọn. Nếu bạn đang mua một CLAP mới và tiếp tục với nó, bạn có thể chọn số 1 và những người khác có thể được chọn tùy theo tình huống của bạn.',
    ledger_live_text_5: '5. Nhấn 3 khi hoàn tất cài đặt ban đầu để tiếp tục.',
    ledger_live_text_6:
      '6. Chọn Ledger Nano S từ ba tùy chọn và nhấn tiếp tục.',
    ledger_live_text_7:
      '7. Có ba danh sách kiểm tra. Vui lòng đặt nó theo tình hình hiện tại của bạn.',
    ledger_live_text_8:
      '8. Sau khi kiểm tra danh sách kiểm tra, hãy nhấp vào Kiểm tra ngay bây giờ thứ ba.',
    ledger_live_text_9:
      '9. Kết nối CLAP với máy tính và mở khóa CLAP. (Đây là quá trình xác minh tính xác thực)',
    ledger_live_text_10:
      '10. Nếu thiết bị của bạn là chính hãng trong danh sách kiểm tra thứ ba, hãy nhấp vào tiếp tục ở dưới cùng bên phải.',
    ledger_live_text_11:
      '11. Trang cài đặt mật khẩu xuất hiện. Bạn có thể đặt hoặc không đặt mật khẩu. Nếu bạn muốn đặt mật khẩu, vui lòng nhấp vào Tiếp tục / Bỏ qua bước này ở phía dưới cùng ngay sau khi nhập.',
    ledger_live_text_12:
      '12. Nhấp vào tiếp tục ở dưới cùng bên phải để tiếp tục.',
    ledger_live_text_13: '13. Cài đặt Ledger Live đã hoàn tất.',
    coin_app_text_1:
      '1. Bật Ledger Live đã được cài đặt trước đó và nhấp vào Đi tới Trình quản lý ở trung tâm.',
    coin_app_text_2: '2. Kết nối CLAP với PC và nhập MÃ PIN',
    coin_app_text_3:
      '3. Khi bạn đã nhập MÃ PIN, hãy nhấn đồng thời cả hai nút phía trên để tiếp tục.',
    coin_app_text_4:
      '4. Tìm tiền điện tử bạn có ở dưới cùng và nhấp vào Cài đặt ở bên phải để liên kết.',
    detail_to_buy: 'chi tiết và nơi mua sắm',
    detail_content1_1:
      'Clap có ý nghĩa rằng danh mục mã hóa của người dùng được cấu hình để đảm bảo rằng tài sản được duy trì một cách an toàn.',
    detail_content1_2:
      'Ngành công nghiệp tài chính toàn cầu đang di chuyển nhanh chóng thông qua việc khám phá và đổi mới các công nghệ mới. Mất điện tử cũng thay đổi và áp dụng theo những thay đổi này, và nhiều công ty toàn cầu đã được chú ý một lần nữa về giá trị của tiền điện tử.',
    detail_content1_3:
      'Người dùng lâu dài có nhiều rắc rối về sự an toàn của tài sản do tính chất của mã hóa chỉ được sử dụng dưới dạng thông tin trên máy tính.',
    detail_title_2: 'Dịch vụ được cung cấp bởi Clap là một số nhất định.',
    detail_content2_1:
      'Coco Bank đánh giá rằng một phần mềm lưu trữ các khóa riêng trong đám mây dễ bị tấn công bên ngoài và vấn đề bảo mật sẽ xảy ra. Chúng tôi khuyên bạn nên giải quyết vỗ tay ví để bổ sung những vấn đề này.',
    detail_content2_2:
      'Clap hỗ trợ tối đa tám ứng dụng và có thể giữ nhiều mã hóa khác nhau như xu, trán và tiders. Bạn cũng có thể giữ tài sản một cách an toàn từ các hack ngoài vì nó không phải là một ví không phải lúc nào cũng được kết nối với Internet.',
    detail_title_3: 'Bảo vệ',
    detail_content3_1:
      'Clap là sự hợp tác (ví lạnh), sự hợp tác với "Ledger" và hợp tác với một công ty giải pháp bảo mật chuyên nghiệp toàn cầu để giải quyết các vấn đề bảo mật của một bức tường nóng (ví hot).',
    detail_content3_2:
      'CLAP đã được áp dụng bởi một giải pháp bảo mật đã được xây dựng bởi 130 kỹ sư toàn cầu với kiến ​​thức và kinh nghiệm bảo mật kỹ thuật số. Chúng tôi đã chèn các chip mã PIN bảo mật mới nhất được sử dụng bởi hộ chiếu và thẻ tín dụng để tăng cường bảo mật.',
    detail_content3_3:
      'Ngay cả khi bạn mất Clap, bạn có thể giữ tài sản mà bạn sở hữu bởi người dùng thông qua thiết bị Clap mới.',
    detail_title_4: 'tiện',
    detail_content4_1:
      'Bạn có thể nhập khóa bí mật bằng hai nút nằm ở đầu Clap.',
    detail_content4_2:
      'Chúng tôi đã hỗ trợ hơn 40 mã hóa, bao gồm Bitcoin, Ethereum và XRP và xem xét sự tiện lợi của người dùng.',
    detail_title_6: 'NHƯ',
    detail_content6_1:
      'A / S cho các thiết bị sản phẩm là một năm kể từ ngày mua.',
    detail_content6_2:
      'Nếu A / S là bắt buộc, vui lòng truy cập ngân hàng Coco với cơ thể vỗ tay.',
    detail_content6_3:
      'Một số sê-ri được gắn vào mặt sau của vỗ tay cho A / S là bắt buộc. A / S không thể được sử dụng để làm suy yếu hoặc loại bỏ số sê-ri.',
    detail_content6_4:
      'A / S có thể không thể tùy thuộc vào sản phẩm của sản phẩm gây ra bởi sự bất cẩn của bạn và trạng thái của sản phẩm.',
    detail_title_7: 'Để ý',
    detail_content7_1:
      'Các dịch vụ trực tuyến của Clap không liên quan đến Ngân hàng Coco vì chúng được phục vụ bởi Ledger.',
    detail_content7_2:
      'Nếu bạn sử dụng sản phẩm, xin lưu ý rằng vấn đề hack từ bên ngoài do vấn đề hack bên ngoài gây ra bởi sự bất cẩn (mất, khôi phục và kết nối mã PIN với PC bị nhiễm) không chịu trách nhiệm cho ngân hàng Coco.',
    detail_content7_3:
      'Các dịch vụ trực tuyến được cung cấp bởi "Ledger Live" hoặc Ledger không liên quan đến số tiền mà người dùng thu được bởi người dùng không liên quan đến ngân hàng Coco.',
    detail_title_8: 'Mua, tựa vào, bám vào',
    detail_content8_1: 'Co.U Co.U (Cafe): 430 tầng 1',
    detail_title_9: 'A / S LƯU Ý',
    detail_content9_1: 'Banco Bank: Seoul, Gangnam-gu, Seoul 528 tầng 2',
    detail_content9_2:
      'Xin vui lòng liên hệ với chúng tôi với Kozuko Koh gần nhất, hoặc help@cocobank.com.',
  },
}
